import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser} from "../../actions/authActions";
import $ from 'jquery';
import moment from 'moment';
import axios from "axios";
import SessionDataStore from "../../streaming/SessionDataStoreController";
import Util from "../../streaming/Util";
import preStreaming from "../../streaming/PreStreamingController";
import classnames from "classnames";
import { updatesse } from '../../utils/updatesse';
import Chat from "./ChatHook";

import { isChrome as chrome, isSafari as safari, isBrowser as browser, isFirefox as ff, osName as osname, fullBrowserVersion as fbrowserversion, browserName, deviceType, isMobileOnly as mobileOnly, isTablet as tablet} from "react-device-detect";
import { ToastContainer, Flip } from 'react-toastify';

import SupportContainer from '../home/SupportContainer';

class PreConfiguration extends Component {

  constructor(props) {
    super(props);

    this.state = {
      users: 0,
      userType:-1,
      sessionDate:'',
      userName:'',
      isTutorialRead:'',
      firstName:'',
      loadParticipantList:false,
      currentUserData: JSON.parse(localStorage.getItem('userData')),
      hideOnlineStatus: false,
  	  testSpeakerStatus: '',
  	  sessionUsers: [],
  	  sessionUsersIds: [],
  	  isOpenUsersDrop: false,
  	  activeMenu: 'Camera Settings',
  	  turnVideoOptions: ["My Instructor (Trainer)", "Other Members", "Me (I dont't want to see myself)"],
  	  turnVideoArray: [],
  	  openedInfo: false,
  	  canStartSession: false,
  	  isHostOnline: false,
  	  feetOptions: ['', 0, 1, 2, 3, 4, 5, 6, 7],
  	  inchOptions: ['', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  	  participantHeightFeet: '',
  	  participantHeightInch: '',
  	  cameraHeightFeet: '',
  	  cameraHeightInch: '',
  	  canSaveRoomSetup: false,
  	  canJoinSession: true,
  	  appsMenu: 'instruction',
  	  appCode: 1234,
  	  emailApps: '',
  	  errorEmail: false,
  	  mounting: true,
  	  showRequiredError: false,
  	  supportPageName: 'Waiting Lounge',
  	  supportPageApi: '/pre-screen',
  	  userTypeFaqs: JSON.parse(localStorage.getItem('userData')).userType,
  	  usersOnline: 0,
  	  showRoomSetup: false,
  	  agesArray: ['', 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70],
      gendersArray: ['', 'Male', 'Female'],
      poundsArray: [],
  	  caloriesAges: '',
  	  caloriesHeightFeet: 5,
  	  caloriesHeightInch: 8,
  	  caloriesGender: '',
  	  caloriesWeight: 190,
  	  canSaveCalories: false,
  	  hasEnteredCalories: false,
      showMicMsg: false,
      showCameraMsg: false,
      onboarding: true,
	  videoResolution: '360p',
	  hasEquipment: false,
	  noRoomSetup: true,
	  recfullState: false,
	  nicTrack: true,
	  recLink: '',
	  saveHeight: true,
	  rtmConnected: false,
	  chatCount : 0,
	  boxJumpSize: '12x12',
	  boxJumpOptions: [7, 10, 12, 14, 16],
	  hasBoxJump: false,
	  useLocation: true,
	  WASRequiredInWaitingLounge: parseInt(JSON.parse(localStorage.getItem('userData')).default.WASRequiredInWaitingLounge),
	  isMarketplaceChannel: JSON.parse(localStorage.getItem('userData')).isMarketplaceChannel,
	  fullAudioInstructions: true,
	  shortAudioInstructions: false,
	  noAudioInstructions: false,
	  audioInstructionsOptions: ['Full Audio Instructions', 'Short Audio Instructions', 'No Audio Instructions'],
	  roomSetupAudioInstructions: 'Full Audio Instructions',
	  isFoundVirtual: false,
	  onceShownHeight: false,
	  hostVideoResolution: '',
	  roomSetupDone: false,
	  userCameraOff: false,
	  hasBoxing: false,
	  boxingPosition: 'Left',
	  boxingOptions: ['Left', 'Right'],
	  numberOfSetupSteps: 2,
	  setupStep: 0,
	  setupStepName: 'Device Settings',
	  setupNames: ['Device Settings', 'Equipment Setup', 'Room Setup', ''],
	  watchAppPopupShown: false,
	  shownWatchAppScreen: 1,
	  roomSetupStep: 1,
	  roomSetupTitle: 'Augmented Reality Requirements',
	  roomSetupText: '<ol><li>After Completing Camera & Room Setup, Do Not Move Your Camera.</li><li>Your Feet And Your Shoulders Must Be Visible In the Camera.</li><li>Do Not Point Camera Towards A Window With Sunlight.</li><li>Do Not Walk Towards the Camera During Virtual Equipment Exercises.</li></ol>',
	  roomSetupTitleNames: ['Augmented Reality Requirements', 'Stand in the marked area', 'Capturing', 'Done', 'Done', 'Joining Class'],
	  roomSetupTextNames: ['<ol><li>After Completing Camera & Room Setup, Do Not Move Your Camera.</li><li>Your Feet And Your Shoulders Must Be Visible In the Camera.</li><li>Do Not Point Camera Towards A Window With Sunlight.</li><li>Do Not Walk Towards the Camera During Virtual Equipment Exercises.</li></ol>', '', '', '', '', ''],
	  roomSetupButtonText: 'Continue',
	  roomSetupSecondButton: '',
	  roomSetupImageNames: ['', '', 'room_setup_loader', 'done_check', 'done_check', 'room_setup_loader'],
	  roomSetupButtonTextNames: ['Continue', 'Skip', '', '', '', ''],
	  roomSetupImage: '',
	  innerHold: false,
	  innerHoldSteps: [false, false, true, true, true, true],
	  allCameraPermissionsTurnedOff: false,
	  dontHaveAnyCam: false,
	  showContinueButton: false,
	  boxJumpWidth: 14,
	  boxJumpHeight: 14,
	  boxingCirclePosition: 1,
	  cameraSelect: 0,
	  onDemand: false,
	  hideTestMic: false,
	  disableVirtualOption: false,
	  disableVirtualPermitted: true
    }
	
	console.log('preConfiguration---1');
	
    this.sessionDataStore = SessionDataStore.getInstance();
	this.roomSetupButtonClicked = false;
	this.alreadyClickedButton = false;
	this.roomAudioPlayed = false;
	this.virtualEnabled = false;
	this.clickedOnSkip = false;
	window.sessionDataStore = this.sessionDataStore;
	window.Util = Util;
    window.mediaAccessAllowed = null;
	window['useEquipmentLocation'] = false;
	window['hasBoxJump'] = false;
	window['hasBoxing'] = false;
	window['hasVirtualEquipment'] = false;
	window.updateParticipantsData = this.updateParticipantsData;
  	window.showJoinPreStreaming = this.showJoinPreStreaming;
  	window.falseJoinPreStreaming = this.falseJoinPreStreaming;
  	window.joinSessionPreStreaming = this.joinSession;
  	window.updateOfflineStatusHost = this.updateOfflineStatusHost;
  	window.updateOnlineStatusHost = this.updateOnlineStatusHost;
  	window.updateStatusMember = this.updateStatusMember;
    window.addToSessionUsers = this.addToSessionUsers;
    window.showMediaErrorMsg = this.showMediaErrorMsg;
    window.rtmConnected = this.rtmConnected;
	window['currentResolution'] = '';
  	this.updatesse = updatesse.bind(this);
	this.codeTimeout = null;
	window['currentUserData'] = this.state.currentUserData;
	window['propsHistory'] = this.props.history;
	this.xInterval = null;
	//window['roomSetupAudioInstructions'] = this.state.audioInstructionsOptions.indexOf(this.state.roomSetupAudioInstructions);
	window['roomSetupAudioInstructions'] = 1;
	window['checkRoomSetup'] = this.checkRoomSetup;
	window['setDefResolutionInstructor'] = this.setDefResolutionInstructor;
	this.clickedOnStartButton = false;
	this.clickedOnFirstSkip = false;
	window['userCameraOff'] = false;
	window['dontHaveAnyCam'] = this.dontHaveAnyCam;
	window['dontHaveAnyMic'] = this.dontHaveAnyMic;
	window['cameraSelectValue'] = this.cameraSelectValue;
	window.showSkipAndRetry = this.showSkipAndRetry;
	window.showSkipAndTryAgain = this.showSkipAndTryAgain;
	window.callMediaTilt = this.callMediaTilt;
	window.showHideRoomSetup = this.showHideRoomSetup;
	window.clearTryAgain = this.clearTryAgain;
	window['alreadyClickedOnSkip'] = false;
	window['hasVirtual'] = false;
	
	console.log('preConfiguration---2');
	
	if ( document.getElementById('replayClassVideo') ) { document.getElementById('replayClassVideo').remove(); }
	console.log('preConfiguration---3');
  }

  rtmConnected = () => {
  		this.setState({ rtmConnected: true });
  }

  showMediaErrorMsg = (type) => {
      if( type == 'mic' ) { this.setState({showMicMsg: true}); }
      else { this.setState({showCameraMsg: true}); }
  }

  callfunction(){
	this.hideWaitingLoungePopup('leaveClassPopup');
    window.leaveLogout();
  }

  componentDidMount(){
	  window.showJoinButton = this.showJoinButton;
	  window.roomSetupNextStep = this.roomSetupNextStep;
	  window.callTiltMessage = this.callTiltMessage;
	  window.changeStepAction = this.changeStepAction;
	  window['calculatingCalledAR'] = false;
	  window['onDemand'] = false;
		if ( window['resetPartWhiteboard'] )
			{
				setTimeout(function(){
					window['resetPartWhiteboard']();
				}, 2000);
			}
	  
		window['nextIsSession'] = false;
		window['inStreamingEnter'] = false;
	  
		// When pre-streaming is accessed turn on saver lock
		if ( window['electron'] && window['electronPowerSaver'] && window['electronPowerSaver'].start && window['electronPowerSaver'].stop )
			{
				if ( window['electronPowerSaverId'] ) { window['electronPowerSaver'].stop(window['electronPowerSaverId']); }
				
				window['electronPowerSaverId'] = window['electronPowerSaver'].start('prevent-display-sleep');
			}

      preStreaming();

      if ( !window['electron'] )
      {
      		if( localStorage.getItem("onboarding") === null )
      		  {
		          this.setState({'onboarding': false});
		          window.deviceAccessAlert('show');
		      }
      }

	  if ( this.state.currentUserData.sessionData.ondemandId > 0 )
		{
			if ( localStorage.getItem('turnOfCamera') ) { localStorage.removeItem('turnOfCamera'); }
			var userDataObj = this.state.currentUserData;
			/*if ( this.state.currentUserData.userType == 2 )
				{
					delete userDataObj.userType;
					this.setState({currentUserData: userDataObj});
					localStorage.setItem('userData', JSON.stringify(userDataObj));
					window.currentUserData = userDataObj;
				}*/
				
			window['onDemand'] = true;
			
			if ( window['onDemand'] )
				{
					this.setState({turnVideoOptions: ["Me (I dont't want to see myself)"], onDemand: true});
					setTimeout(function(){
						window.showJoinButton();
					}, 15000);
				}
			
			// window.rtmJoin();
			
			// window.getDevicesOnDemand();
			// console.log('ondemand', this.state.onDemand);
			
			// this.getVideoResolution();
			
			this.init(this.state.currentUserData);
		}
	  else 
		{
			console.log('ondemand', this.state.onDemand);
			this.init(this.state.currentUserData);
		}
		
      if(mobileOnly === false && tablet === true && osname == "Mac OS") {
          window['ipad'] = true;
      }
	  
      let lbs = [''];

      for ( let i=80; i<=450; i++ )
      {
          lbs.push(i);
      }

      this.setState({'poundsArray': lbs});

	  this.getRoomSetup(); 
	  this.getCaloriesInfo(); 
	  this.getCode();
	  var mainthis = this;
	  var localstoragedata = JSON.parse(localStorage.getItem('userData'));
	  var videoParResolution = localstoragedata.videoResolutionParticipant;
	  var chosenResolution = videoParResolution == 1 ? 'hd' : videoParResolution == 0 ? 'sd' : 'hdp';
	  window['currentResolution'] = chosenResolution;
	  this.setState({
		  videoResolution: chosenResolution
	  });
		mainthis.updatesse('watchUserId', [mainthis.state.currentUserData.id], function ()
			{
				setTimeout(function(){ mainthis.checkAppCode(); 
					
	console.log('preConfiguration componentDidMount---16');
				}, 1000);
			});
			
    mainthis.updatesse('pendingSessionUsers', [localstoragedata.sessionData.id], function (passData)
      {
          //console.log('passData - ', passData);
          
	console.log('preConfiguration componentDidMount---17');
          let userData = passData.split('|');

          if ( userData[0] == localstoragedata.sessionData.hostId )
          {
              $('#hostStuckMsg').removeClass('d-none');
              setTimeout(function(){ 
                $('#hostStuckMsg').addClass('d-none');
              }, 15000);
          }
      });
		
	this.saveBoxJump('hostInfo');
	this.saveRoomInstructions('hostInfo');
	
	if ( this.state.currentUserData.type == 1 ) { this.setState({isHostOnline: true}); }
	this.checkForVirtual();
	
	if ( this.state.currentUserData.type == 1 && this.state.currentUserData.isMarketplaceChannel == 1 )
		{
			window['currentResolution'] = '1080p';
			this.setState({hostVideoResolution: '1080p'},()=>{
				window.setUserProfilePrestreaming(this.state.hostVideoResolution);
			});
			localStorage.setItem("video-resolution", '1080p');
		}
		
	window['currentlyOnPrestreaming'] = true;
	
	if ( localStorage.getItem('turnOfCamera') )
		{
			let cameraDisableStatus = localStorage.getItem('turnOfCamera');
			this.changeTurningOff(cameraDisableStatus, false);
		}
		
	var counterId = localStorage.getItem('unreadMessagesClassId');
	if ( counterId )
		{
			let numCounter = localStorage.getItem('unreadMessagesNum');
			if ( parseInt(counterId) == parseInt(localstoragedata.sessionData.id) && parseInt(numCounter) )
				{
					this.setState({
						chatCount: parseInt(numCounter),
					})
				}
		}
	
	if ( !window['electron'] )
		{
			this.disableVirtual(true);
			window['detectionDisabled'] = true;
		}
	console.log(localStorage.getItem('recalibrationHidden'), 'recalibrationHidden');
	 if ( localStorage.getItem('recalibrationHidden') == null || JSON.parse(localStorage.getItem('recalibrationHidden')) === false || JSON.parse(localStorage.getItem('recalibrationHidden')) === true || ( localStorage.getItem('recalibrationHidden') && JSON.parse(localStorage.getItem('recalibrationHidden')).sessionId && JSON.parse(localStorage.getItem('recalibrationHidden')).sessionId != this.state.currentUserData.sessionData.id ) )
		{
			var recalibrationObject = JSON.stringify({'sessionId': this.state.currentUserData.sessionData.id, 'value': false});
			console.log(recalibrationObject, 'recalibrationObject');
			localStorage.setItem('recalibrationHidden', recalibrationObject);
		}
	
	console.log('loadPreVideoElement didMount ondemandId', this.state.currentUserData.sessionData.ondemandId);
	if ( this.state.currentUserData.sessionData.ondemandId > 0 || this.state.currentUserData.sessionData.replayClassId > 0 )
		{
			this.loadPreVideoElement();
		}
  }
  
  componentWillUnmount(){
	  clearTimeout(this.codeTimeout);
	  clearInterval(this.xInterval);
	  this.xInterval = null;
	  window['currentlyOnPrestreaming'] = false;
	  window['devicesLoaded'] = false;
  }
  
  updateStatusMember = (userId, mod, val='') => {
	  console.log('updateStatusMember PreConfiguration');
	  console.log(userId);
	  var users = this.state.sessionUsers;
	  console.log('users');
	  console.log(users);
	  for ( var i = 0; i < users.length; i++ )
		  {
				if ( users[i].id == userId )
					{
						if ( mod == 'cameraAccess' || mod == 'micAccess' ) { users[i][mod] = val; }

						if ( mod == 'offline' ) { users[i]['isOnline'] = false; }
						else { users[i]['isOnline'] = true; }
					}
		  }
		
		console.log('##users ---- ', users);
		this.setState({participantList: users});
    this.userList(this.state.users);
	window.getSessionUsers();
  }

  init = (localstoragedata) => {
	  console.log('init PreConfiguration');
	  let mainthis = this;
	  let userType = 'participant';
	  if ( localstoragedata['sessionData']['hostId'] == this.state.currentUserData.id)
		{
			userType = 'host';
			
			if ( !window['onDemand'] )
				{
					this.setState({disableVirtualPermitted: false});
				}
		}
	  
	  this.countdownTimer(localstoragedata.sessionData.scheduleDate);

      let platformDetails = '';

      if ( window['electron'] ) {
          let appVersion = '';
          if ( window.navigator.appVersion.indexOf('Windows') == -1 )
          {
              appVersion = localstoragedata.default.appVersionApple;
          }
          else
          {
              appVersion = localstoragedata.default.appVersionWindows;
          }
		
			var appVersionN = '';
			if ( window['currentAppVersion'] ) { appVersionN = window['currentAppVersion']; }
			
			platformDetails = {OS:osname, Browser:'Native', Version: appVersion, VersionApp: appVersionN}
      } else {
          platformDetails = {OS:osname, Browser:browserName, Version:fbrowserversion, DeviceType:deviceType}
      }

      let addObject = {"sessionId": localstoragedata.sessionData.id,  "userId": localstoragedata.id, "event": "device", "eventType": "platform", "details": JSON.stringify(platformDetails), "timestamp": Util.getCurrentTimestamp()};
      this.sessionDataStore.addSessionData(addObject);

      this.fetchUsers();
  }
	
  joinSession = (localstoragedata) => {
	  console.log('localstoragedata', localstoragedata);
	  if ( this.state.chatCount > 0 )
		{
			 localStorage.setItem("unreadMessagesNum", this.state.chatCount);
		}
	 else 
		{
			localStorage.removeItem('unreadMessagesNum');
		}		
	  localstoragedata = JSON.parse(localStorage.getItem('userData'));

		let addObject = {"sessionId": localstoragedata.sessionData.id,  "userId": localstoragedata.id, "event": "status", "eventType": "joinSession", "details": JSON.stringify({"msg": "Join Class button clicked on Waiting Lounge"}), "timestamp": Util.getCurrentTimestamp()};
    this.sessionDataStore.addSessionData(addObject);
	
    localstoragedata = JSON.parse(localStorage.getItem('userData'));
	window['calculateAssessmentDimensions'] = localstoragedata.sessionData.calculateAssessmentDimensions;
	
	if ( this.state.currentUserData.userType == 2 && localStorage.getItem('turnOfCamera') )
		{
			var disabledCameraOptions = JSON.parse(localStorage.getItem('turnOfCamera'));
	
			if ( disabledCameraOptions )
				{
					disabledCameraOptions.forEach( (item) => { 
						if ( item == "Me (I dont't want to see myself)" )
							{
								this.setState({
									userCameraOff: true
								});
								window['userCameraOff'] = true;
							}
					});
				}
		}
	
	var roomSetDone = this.checkRoomSetup();
	
	if ( localstoragedata && localstoragedata.sessionData.scriptDetail.length > 0 )
		{
			var isFoundEquipment = false;
			var isFoundEquipment2 = true;
			var activity = localstoragedata.sessionData.scriptDetail;
			for ( var i = 0; i < activity.length; i++ )
				{
					for ( var a = 0; a < activity[i].attribute.length; a++ )
						{
							if ( activity[i].attribute[a].attrLabel === 'Activity Type' )
								{
									if ( activity[i].attribute[a].attrValue === 'Virtual Assistant' || activity[i].attribute[a].attrValue === 'Virtual Equipment' )
										{
											isFoundEquipment = true;
											window['hasVirtualEquipment'] = true;
											this.setState({ hasEquipment: true });
											if ( ( localstoragedata.sessionData.turnoffRoomSetup != undefined && localstoragedata.sessionData.turnoffRoomSetup == 0 ) || ( this.state.currentUserData.isMarketplaceChannel == 1 ) )
												{
													this.setState({ noRoomSetup: false });
												}
										}
								}
								
							if ( activity[i].name == 'Box Horizontal' )
								{
									window['hasBoxJump'] = true;
									this.setState({ hasBoxJump: true },()=>{ this.checkForSave(); });
								}
							else if ( activity[i].name == 'Boxing Bag 1' || activity[i].name == 'Boxing Bags 2 - NEW' )
								{
									window['hasBoxing'] = true;
									this.setState({ hasBoxing: true });
								}
						}
				}
				console.log('joinSession isFoundEquipment', isFoundEquipment);
				console.log('joinSession usingMarkup', localstoragedata.sessionData.usingMarkup);
				console.log('joinSession roomSetDone', roomSetDone);
				console.log('joinSession onceShownHeight', this.state.onceShownHeight);
			if ( ( isFoundEquipment || localstoragedata.sessionData.usingMarkup == 1 ) && ( !roomSetDone || !this.state.onceShownHeight ) && window['electron'] && !window['userCameraOff'] && !this.state.dontHaveAnyCam )
				{
				console.log('joinSession roomIsSetup');
					$('#local-media').addClass('roomIsSetup');
					this.setState({showRoomSetup: true, onceShownHeight: true, activeMenu: 'Camera Settings'});
					window['hasConeScript'] = true;
				}
			else { this.joinSessionOld(localstoragedata); }
		}
	else if ( localstoragedata && localstoragedata.sessionData && localstoragedata.sessionData.usingMarkup == 1 && ( !roomSetDone || !this.state.onceShownHeight ) && window['electron'] && !window['userCameraOff'] && !this.state.dontHaveAnyCam )
		{
			$('#local-media').addClass('roomIsSetup');
			this.setState({showRoomSetup: true, onceShownHeight: true, activeMenu: 'Camera Settings'});
		}
	else
		{
			this.joinSessionOld(localstoragedata);
		}
  }
	  
	  
  joinSessionOld = (localstoragedata) => {
		console.log('joinSessionOld',localstoragedata );
		this.applyCameraRestrict();
		if ( this.state.recfullState ) { window['startManualRecordingTest'] = true; }
		if ( this.state.nicTrack ) { window['checkFeetTracker'] = true; }
		if ( this.state.useLocation ) { window['useEquipmentLocation'] = true; }
		if ( this.state.recLink )
			{
				window['saveRecPath'] = this.state.recLink;
				window['saveRecPath'] = window['saveRecPath'].replace(/\\/g, '/');
				window['saveRecPath'] = window['saveRecPath'] + (window['saveRecPath'].substr(-1) == '/' ? '' : '/');
			}
		
	  $('#local-media').find('canvas').remove();
	  $('#local-media').removeClass('roomIsSetup');
      window.removePreScreenSession();
      
      if(localstoragedata.sessionData.userType != ''){
        let mediaSetting = {};
       
	    //mediaSetting['camera'] = $('input[name="video-type"]').length > 0 ? $('input[name="video-type"]:checked').val():null;
	    mediaSetting['camera'] =  window['cameraValue'] ? window['cameraValue'] : null;
        mediaSetting['microphone'] = $('#select_microphone').length > 0 ? $('#select_microphone').val():null;
        mediaSetting['speaker'] = $('#select_speakers').length > 0 ? $('#select_speakers').val():null;
		
		if ( mediaSetting['camera'] == null && window['newCameraArrayList'] && window['newCameraArrayList'][0] && window['newCameraArrayList'][0]['value'] )
			{
				mediaSetting['camera'] = window['newCameraArrayList'][0]['value'];
			}
		
		
        localStorage.setItem("media-setting", JSON.stringify(mediaSetting));

        window.$('#multi-media-access-alert').modal('hide');
		console.log('joinSessionOld1');
        if(localstoragedata.sessionData.userType == 1 && localstoragedata.sessionData.isTutorialRead===1 && !this.state.onDemand) 
			{		console.log('joinSessionOld1');
			  let tutorialData = {};
			  tutorialData['sessionId'] = this.state.currentUserData.sessionData.id;
			  tutorialData['tutorialStatus'] = 1;
			  localStorage.setItem("tutorialData", JSON.stringify(tutorialData));
			  window['isTutorialStarted'] = 1;
			  this.props.history.push('/host');
			}
        else if(localstoragedata.userType == 1 && !this.state.onDemand){		console.log('joinSessionOld1');
    			if ( window['electron'] ) { this.props.history.push("/host"); } else { window.location = '/host'; }
    		}
        else if(localstoragedata.sessionData.userType == 1 && !this.state.onDemand){		console.log('joinSessionOld1');
          if ( window['electron'] ) { this.props.history.push("/host"); } else { window.location = '/host'; }
        } else {
			if ( this.state.onDemand )
				{
					if ( window['localStreamOnDemandGlobal'] )
						{ 
							window['localStreamOnDemandGlobal'].getVideoTracks().forEach(function(track) { track.stop(); });
							window['localStreamOnDemandGlobal'] = null;
						}
					
					//this.props.history.push("/ondemand");
					console.log('ondemand222');
					this.props.history.push("/guest");
				}
			else 
				{
					this.props.history.push("/guest");
				}
		}
      } else {
        window.location.href  = window['electron'] ? 'index.html' : '/login';
      }
	console.log('joinSessionOld2');
  }

  addToSessionUsers = (userdata) => {
	  console.log('addToSessionUsers')
      var userList = this.state.users;
      userList.push(userdata);
      
      var participantList = this.state.sessionUsers;
      participantList.push(userdata);

      var participantUserIds = this.state.sessionUsersIds;
      participantUserIds.push(userdata.id);

	  if ( window['addUserToGlobalModel'] )
		{
			console.log('addUserToGlobalModel-------',userdata);
			window['addUserToGlobalModel'](userdata);
		}

	   this.setState({
		   users: userList,
		   sessionUsers: participantList,
		   sessionUsersIds: participantUserIds
	   }, ()=> { this.updateStatusMember(userdata.id, 'online'); });
     // setTimeout(() => { this.updateStatusMember(userdata.id, 'online'); }, 1000);
  }

  userList(userList) {
	  console.log('userList PreConfiguration');
	  var participantList = this.state.sessionUsers;
	  var participantListIds = this.state.sessionUsersIds;
	  var imgPath = './images/user_avatar.svg';

	  for ( var i = 0; i < userList.length; i++ )
		  {
			  //if ( ( userList[i].hostStatus == undefined || userList[i].hostStatus == 0 ) && participantListIds.indexOf(userList[i].id) == -1 )
			  if ( participantListIds.indexOf(userList[i].id) == -1 )
				  {
					  if ( !userList[i].image || userList[i].image == 'null' || ( userList[i].image !== '' && userList[i].image.indexOf('.s3') == -1 ) )
						  {
							  userList[i].image = imgPath;
						  }
						  
					if ( userList[i].id == this.state.currentUserData.id )
						{
							userList[i]['isOnline'] = true;
						}
					  
					  participantList.push(userList[i]);
					  participantListIds.push(userList[i].id);
				  }
		  }
		
		var countOnline = 0;
		var j = 1;
		var k = 100;
		for ( var i = 0; i < participantList.length; i++ )
			{
				if ( participantList[i].isOnline && participantList[i].id != this.state.currentUserData.sessionData.hostId ) { countOnline++; participantList[i].dataPosition = j++; }
				else if ( participantList[i].isOnline === false || participantList[i].isOnline == undefined ) { participantList[i].dataPosition = k++; }
			}

	localStorage.setItem("tempUsers", JSON.stringify(userList));
    this.setState({loadParticipantList: true, sessionUsers: participantList, sessionUsersIds: participantListIds, usersOnline: countOnline});
  }

  modalClose = e => {
    window.leaveLogout();
  }

  partmodalClose = e => {
    $("#participent_host_alert").attr({'style':'display:none'});
  }
  
  updateOfflineStatusHost = () => {
	 this.setState({isHostOnline: false});  
  }
  
  updateOnlineStatusHost = () => {
	 this.setState({isHostOnline: true});  
  }
  
  showJoinPreStreaming = () => {
		this.setState({canStartSession: true, showContinueButton: true});
   }
   
  falseJoinPreStreaming = () => {
		this.setState({canStartSession: false});
   }
   
   updateParticipantsData = (id, key, value) => {
	   console.log('updateParticipantsData');
	   if ( this.state.sessionUsers && this.state.sessionUsers.length > 0 )
		{
			for( let i=0; i<this.state.sessionUsers.length; i++ )
				{
					console.log(this.state.sessionUsers[i]);
					if ( this.state.sessionUsers[i]['id'] == id )
						{
							console.log('MATCH');
							this.state.sessionUsers[i][key] = value;
						}
				}
		}
   }

  countdownTimer(sessionDate) {
	  
    var deadline = new Date(sessionDate).getTime();
    let userData = JSON.parse(localStorage.getItem("userData"));
	 var mainthis = this;
	  
	console.log("USER DATA---", userData);
	
	if ( userData.sessionData.replayClassId > 0 )
		{
			/* $('.session_info_content').text('Class Started');
			this.setState({canStartSession: true});
			return false; */
		}
	
	if ( userData.sessionData.ondemandId > 0 )
		{
			return false;
		}
		
	var sessionData = userData.sessionData;
	
	let currDate = new Date(sessionData.scheduleDate);
	  var now = new Date().getTime();
	  let timeLeftToStart = currDate - now;
	  const memberCanJoinSession = userData.default.hasOwnProperty('d2c_memberCanJoinSession') ? parseInt(userData.default.d2c_memberCanJoinSession) : false;
	  if (memberCanJoinSession) {
		  timeLeftToStart -= (memberCanJoinSession * 1000);
	  }// will wait 15 sec for rtm to appear
	  
	  if (timeLeftToStart < 1) { // TODO disable this if behaviour not needed
		  if ( JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel && JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel == 1 )
			{
				this.showJoinButton();
				console.log('MATCH1');
			}
	  } else {
			if ( JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel && JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel == 1 )
				{
					console.log('MATCH2');
					setTimeout(this.showJoinButton, timeLeftToStart)
				}
	  }

	var deadlineEnd =  new Date(currDate).getTime(); 
	var startTimeReplay = 0;
    this.xInterval = setInterval(function() {
          var now = new Date().getTime(); 
          var t = deadline - now;
          var timeRemaining = deadlineEnd - now;
          var seconds = ("0" + (Math.floor((t / 1000) % 60) % 60)).slice(-2);
          var minutes = ("0" + Math.floor((t / 60000) % 60)).slice(-2);
          var hours = Math.floor((t / 3600000));
          
          if(hours >= 100) {
            hours = ("0" + hours).slice(-3);
          } else {
            hours = ("0" + hours).slice(-2);
          }

          let time = 'Class starts in: '+ minutes + ':' + seconds;
     
          if ( !mainthis.state.canStartSession ) { $('.session_info_content').text(time); }
		  
		  if ( ( sessionData.replayClassId > 0 && userData.userType == 2 ) || ( sessionData.ondemandId && sessionData.ondemandId > 0 ) )
			{
				var rtmCodes = sessionData.rtmCodes;
				var rtmTimes = sessionData.rtmTimes;
				
				if ( startTimeReplay == 0 && rtmCodes && rtmCodes.length )
					{
						for ( var i = 0; i < rtmCodes.length; i++ )
							{
								if ( rtmCodes[i].rtmCode.indexOf("217") > -1 ) 
									{
										var startVarSplit = rtmCodes[i].time.split(":");
										if ( startTimeReplay == 0 )
											{
												startTimeReplay = (parseInt(startVarSplit[0]) * 60) + parseInt(startVarSplit[1]);
											}
									}
							}
					}					
				
				let allMinutes = Math.floor(timeRemaining / 60000);
				var allSeconds = ("0" + (Math.floor((timeRemaining / 1000) % 60) % 60)).slice(-2);
				if ( parseInt(allMinutes) < 10 )
					{
						allMinutes = "0" + allMinutes;
					}
					
				let timeMember = allMinutes + ':' + allSeconds;
				var timeMemberNum = (parseInt(allMinutes) * 60) + parseInt(allSeconds);
				
				if ( timeMemberNum < startTimeReplay  )
					{
						$('.session_info_content').text('Class Started');
						mainthis.setState({canStartSession: true, showContinueButton: true});
						mainthis.updateOnlineStatusHost();
					}
				else
					{
						if ( rtmTimes && rtmTimes.indexOf(timeMember) > -1 )
							{
								if ( rtmTimes.indexOf(timeMember) > -1 )
									{
										var indexOf = rtmTimes.indexOf(timeMember);
										var rtmToSend = rtmCodes[indexOf];
										if ( rtmToSend['rtmCode'].indexOf("217") > -1 )
											{
												$('.session_info_content').text('Class Started');
												mainthis.setState({canStartSession: true, showContinueButton: true});
												mainthis.updateOnlineStatusHost();
											}										
									}
							}
					}
			}

          if (t < 0) {
              clearInterval(mainthis.xInterval);
			  mainthis.xInterval = null;
              $('.session_info_content').text('Class Started');

              if(userData.userType == 1) {
                
				 var redirectCounter = setInterval(function() {
                    if ($('#multi-device-login-alert').hasClass('show') === false) {
                        if(localStorage.getItem("video-resolution") != null && window.mediaAccessAllowed === true) {
							
                            clearInterval(redirectCounter);
							redirectCounter = null;

                            mainthis.setState({canStartSession: true, showContinueButton: true});
                            window.play_notification_sound();

                            setTimeout(() => {
                                window.checkHostJoinedRTM();
                            }, 10000);
                        }
                    } else {
                        clearInterval(redirectCounter);
						redirectCounter = null;
                    }
                  }, 1000);
              } else {
                  if ( sessionData.replayClassId == 0 && (!sessionData.ondemandId || sessionData.ondemandId == 0) ) 
					  {
						 if ( !mainthis.state.canJoinSession )
							{
								$('.session_info_content').text('Waiting for '+userData.sessionData.hostFirstName+' to start the class');
							}
						  else 
							{
								$('.session_info_content').text('Class Started');
							}							  
						  
						  
						  setTimeout(() => {
							  window.checkHostOnline();
						  }, 10000);
					  }
              }
          } else if(userData.userType == 1) {
              if ($('#multi-device-login-alert').hasClass('show') === false) {
                  if(localStorage.getItem("video-resolution") != null && window.mediaAccessAllowed === true) {
					            mainthis.setState({canStartSession: true, showContinueButton: true});
                  }
              }
          }
    }, 1000); 
  }

  fetchUsers = () => {
	  console.log('fetchUsers PreConfiguration');
      window.getSessionUsers().then((response) => {
          for (let i=0; i<response.length; i++)
			{
				response[i]['broadcastVideo'] = null;
				response[i]['broadcastVideoHost'] = null;
				response[i]['isOnline'] = false;
			}
			
		  this.setState({ users: response });
          this.userList(response);

          window.rtmJoin();

          if ( this.state.onboarding === true )
          {
              window.getDevices();
          }

          window.networkBandwidth();
      }).catch(error => {
          this.fetchUsers();
      });
  }

  grantAccess = () => {
	if ( window['writeToFile'] ) { window['writeToFile']('{}'); }
    localStorage.setItem("onboarding", true);
    window.deviceAccessAlert('hide');
    window.getDevices();
  }

  joinWithoutCamera = () => {
      window.mediaAccessAllowed = true;
      window.joinWithoutCameraAlertClose();
      this.disableVirtual(true);
	  window['userCameraOff'] = true;
      let addObject = {"sessionId": this.state.currentUserData.sessionData.id,  "userId": this.state.currentUserData.id, "event": "device", "eventType": "access", "details": JSON.stringify({"action": "Joined Without Camera"}), "timestamp": Util.getCurrentTimestamp()};
      this.sessionDataStore.addSessionData(addObject);
	  $('.prestreaming_nocam').removeClass('d-none');
  }
  
  joinWithoutMicrophone = () => {
      window.mediaAccessAllowed = true;
      
	  window.joinWithoutMicrophone();
	  
      let addObject = {"sessionId": this.state.currentUserData.sessionData.id,  "userId": this.state.currentUserData.id, "event": "device", "eventType": "access", "details": JSON.stringify({"action": "Joined Without Microphone"}), "timestamp": Util.getCurrentTimestamp()};
      this.sessionDataStore.addSessionData(addObject);
  }

  WindowsEdgeMsg=()=>{
    return (
        <div>
            <p className="text-white font-22 px-3">To enable camera access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the camera icon in the URL bar</li>
                  <li>Allow Virdio access to camera</li>
                </ul>
            </p>
        </div>
    )};

  WindowsEdgeMsgMic=()=>{
    return (
        <div>
            <p className="text-white font-22 px-3">To enable microphone access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the Lock icon in the URL bar</li>
                  <li>Allow Virdio access to microphone</li>
                </ul>
            </p>
        </div>
    )};

  WindowsChromeMsg=()=>{
    return (
        <div>
            <p className="text-white font-22 px-3">To enable camera access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the camera icon in the URL bar</li>
                  <li>Allow Virdio access to camera</li>
                </ul>
            </p>
        </div>
    )};

  WindowsChromeMsgMic=()=>{
    return (
        <div>
            <p className="text-white font-22 px-3">To enable microphone access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the Lock icon in the URL bar</li>
                  <li>Allow Virdio access to microphone</li>
                </ul>
            </p>
        </div>
    )};
    
  WindowsFirefoxMsg=()=>{
    return (
        <div>
          <p className="text-white font-22 px-3">To enable camera access please follow these steps.</p>
          <p className="text-white font-22 px-4 pt-3">
              <ul>
                <li>Click on the camera icon next to the URL bar</li>
                <li>Click the x button next to camera blocked</li>
                <li>Refresh the browser</li>
              </ul>
          </p>
        </div>
    )};

  WindowsFirefoxMsgMic=()=>{
    return (
        <div>
          <p className="text-white font-22 px-3">To enable microphone access please follow these steps.</p>
          <p className="text-white font-22 px-4 pt-3">
              <ul>
                <li>Click on the microphone icon next to the URL bar</li>
                <li>Click the x button next to microphone blocked</li>
                <li>Refresh the browser</li>
              </ul>
          </p>
        </div>
    )};

  linuxosChromeMsg=()=>{
    return (
      <div>
          <p className="text-white font-22 px-3">To enable camera access please follow these steps.</p>
          <p className="text-white font-22 px-4 pt-3">
              <ul>
                <li>Click on the camera icon in the URL bar</li>
                <li>Allow Virdio access to camera</li>
              </ul>
          </p>
      </div>
  )};

  linuxosChromeMsgMic=()=>{
    return (
      <div>
          <p className="text-white font-22 px-3">To enable microphone access please follow these steps.</p>
          <p className="text-white font-22 px-4 pt-3">
              <ul>
                <li>Click on the Lock icon in the URL bar</li>
                <li>Allow Virdio access to microphone</li>
              </ul>
          </p>
      </div>
  )};

  linuxosFirefoxMsg=()=>{
    return (
        <div>
            <p className="text-white font-22 px-3">To enable camera access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the camera icon next to the URL bar</li>
                  <li>Click the x button next to camera blocked</li>
                  <li>Refresh the browser</li>
                </ul>
            </p>
        </div>
    )};

  linuxosFirefoxMsgMic=()=>{
    return (
        <div>
            <p className="text-white font-22 px-3">To enable microphone access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the microphone icon next to the URL bar</li>
                  <li>Click the x button next to microphone blocked</li>
                  <li>Refresh the browser</li>
                </ul>
            </p>
        </div>
    )};

  MacosChromeMsg=()=>{
    return (
        <div>
            <p className="text-white font-22 px-3">To enable camera access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the camera icon in the URL bar</li>
                  <li>Allow Virdio access to camera</li>
                </ul>
            </p>
        </div>
    )};

  MacosChromeMsgMic=()=>{
    return (
        <div>
            <p className="text-white font-22 px-3">To enable microphone access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the Lock icon in the URL bar</li>
                  <li>Allow Virdio access to microphone</li>
                </ul>
            </p>
        </div>
    )};

  MacosFirefoxMsg=()=>{
      return (
          <div>
            <p className="text-white font-22 px-3">To enable camera access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the camera icon next to the URL bar</li>
                  <li>Click the x button next to camera blocked</li>
                  <li>Refresh the browser</li>
                </ul>
            </p>
          </div>
      )};

  MacosFirefoxMsgMic=()=>{
      return (
          <div>
            <p className="text-white font-22 px-3">To enable microphone access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the microphone icon next to the URL bar</li>
                  <li>Click the x button next to microphone blocked</li>
                  <li>Refresh the browser</li>
                </ul>
            </p>
          </div>
      )};

  MacosSafariMsg = () => {
      return (
          <div>
            <p className="text-white font-22 px-3">To enable camera access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Refresh the browser</li>
                  <li>Allow camera access</li>
                </ul>
            </p>
          </div>
      )};

  MacosSafariMsgMic = () => {
      return (
          <div>
            <p className="text-white font-22 px-3">To enable microphone access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Refresh the browser</li>
                  <li>Allow microphone access</li>
                </ul>
            </p>
          </div>
      )};

  MacosElectronMsg = () => {
      return (
          <div>
            <p className="text-white font-22 px-3">To enable camera access please follow these steps.</p>
            <div className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the “Apple” icon</li>
                  <li>Select System Preferences</li>
                  <li>Select Security and Privacy</li>
                  <li>Select Camera & Microphone</li>
                  <li>Allow the Virdio App access</li>
                </ul>
            </div>
          </div>
      )};

  WindowElectronMsg = () => {
      return (
          <div>
            <p className="text-white font-22 px-3">To enable camera access please follow these steps.</p>
            <p className="text-white font-22 px-4 pt-3">
                <ul>
                  <li>Click on the “Windows” icon in the bottom left corner</li>
                  <li>Select Settings</li>
                  <li>Select Privacy</li>
                  <li>Select Camera & Microphone</li>
                  <li>Allow the Virdio App access</li>
                </ul>
            </p>
          </div>
      )};
	  
openUsers=()=>{
	var openedDrop = this.state.isOpenUsersDrop;
	openedDrop = !openedDrop;
	this.setState({isOpenUsersDrop: openedDrop});
}

	showJoinButton = () => {
		console.log('[Auto Show Join Button]');
		this.setState({canStartSession: true, showContinueButton: true});
	}

openInfoApps=()=>{
	var openedInfoVar = this.state.openedInfo;
	openedInfoVar = !openedInfoVar;
	this.setState({openedInfo: openedInfoVar});
}

changeMenu=(menu)=>{
	if ( menu === 'Connect Watch' && !this.state.hasEnteredCalories && JSON.parse(localStorage.getItem('userData')).userType === 2 )
		{
			menu = 'Track calories burned';
			window.$('#calories_watch_error').modal('show'); 
			setTimeout(function(){ window.$('#calories_watch_error').modal('hide'); }, 2000);
		}
	
	this.setState({activeMenu: menu});
	if ( menu !== 'Connect Watch' ) { this.setState({openedInfo: false}); }
}

changeAppsMenu=(menu)=>{
	this.setState({appsMenu: menu});
}

changeBoxingPosition=(mod)=>{
	this.setState({
		boxingPosition: mod
	});
	
	window['bagPosition'] = mod == 'Left' ? 'leftPosition' : 'rightPosition';
	
	var sendBoxingPosition = 0;
	if ( mod == 'Left' ) { sendBoxingPosition = 0; }
	else if ( mod == 'Right' ) { sendBoxingPosition = 1; }
	this.saveBoxingPosition('boxingPosition', sendBoxingPosition);
}

changeBoxingCirclePosition=(mod)=>{
	this.setState({
		boxingCirclePosition: mod
	});
	
	this.saveBoxingPosition('boxingCirclePosition', mod);
}

changeTurningOff=(mod, addRemoveOption = true)=>{
	let mainthis = this;
	let currentArray = [];
	if ( localStorage.getItem('turnOfCamera') )
		{
			currentArray = JSON.parse(localStorage.getItem('turnOfCamera'));
		}

  if ( addRemoveOption )
	  {
			let spliceStatus = false;
					
			if ( window['onDemand'] )
				{
					if ( currentArray.length == 0 )
						{
							this.setState({allCameraPermissionsTurnedOff: true});
							this.disableVirtual(true);
							window['userCameraOff'] = true;
						}
					else if ( !this.state.disableVirtualOption )
						{
							window['userCameraOff'] = false;
							this.virtualEnabled = true;
						}
				}
			
			if ( currentArray.length > 0 )
				{
					
					if ( currentArray.indexOf(mod) > -1 )
						{
							currentArray.splice(currentArray.indexOf(mod), 1);
							if ( window['electron'] && currentArray.length == 2 )
								{
									if ( window['globalAgora'] && window['globalAgora'].agora )
										{
											window['globalAgora'].agora.enableLocalVideo(true);
											/*this.setState({allCameraPermissionsTurnedOff: false});
											
											if ( window['hasBoxing'] || window['hasBoxJump'] )
												{
													this.setState({
														setupNames: ['Device Settings', 'Equipment Setup', 'Room Setup', ''],
														numberOfSetupSteps: 2,
													});
													this.virtualEnabled = true;
												}*/
										}
								}
								this.setState({allCameraPermissionsTurnedOff: false});
								
								if ( window['hasBoxing'] || window['hasBoxJump'] && !this.state.disableVirtualOption )
									{
										this.setState({
											setupNames: ['Device Settings', 'Equipment Setup', 'Room Setup', ''],
											numberOfSetupSteps: 2,
										});
										this.virtualEnabled = true;
									}
						}
					else 
						{
							currentArray.push(mod);
							if ( currentArray.length == 3 )
								{
									if ( window['electron'] )
										{
											if ( window['globalAgora'] && window['globalAgora'].agora )
												{
													window['globalAgora'].agora.enableLocalVideo(false);
													/*this.setState({allCameraPermissionsTurnedOff: true});
													this.disableVirtual(true);*/
												}
										}
									this.setState({allCameraPermissionsTurnedOff: true});
									this.disableVirtual(true);
								}
						}				
				}
			  else 
				{
					currentArray.push(mod);
				}
	  }
	 
	if ( currentArray.length > 0 )
		{
			localStorage.setItem('turnOfCamera', JSON.stringify(currentArray));
			this.setState({
				turnVideoArray: currentArray,
			});
			
			if ( currentArray.length == 3 && !addRemoveOption )
				{
					if ( window['electron'] )
						{
							if ( window['globalAgora'] && window['globalAgora'].agora )
								{
									window['globalAgora'].agora.enableLocalVideo(false);
								} 
							else
								{
									var checkIfAgoraDefined = setInterval(function() {
										if ( window['globalAgora'] && window['globalAgora'].agora ) {
											window['globalAgora'].agora.enableLocalVideo(false);
											mainthis.setState({allCameraPermissionsTurnedOff: true});
											clearInterval(checkIfAgoraDefined);
											checkIfAgoraDefined = null;
											mainthis.disableVirtual(true);
										} 
									  }, 1000);
								}
						}
					this.setState({allCameraPermissionsTurnedOff: true});
					this.disableVirtual(true);
				}
		}
	else 
		{
			localStorage.setItem('turnOfCamera', '');
			this.setState({
				turnVideoArray: [],
			});
		}
}

handleFilterChange = e => {
	var value;
	if ( e.target.id === 'caloriesGender' || e.target.id === 'boxJumpSize' || e.target.id === 'roomSetupAudioInstructions' || e.target.id === 'boxingPosition' || e.target.id === 'boxJumpHeight' || e.target.id === 'boxJumpWidth' ) 
		{ 
			value = e.target.value;
			if ( e.target.id === 'roomSetupAudioInstructions' )
				{
					window['roomSetupAudioInstructions'] = 1;
					//window['roomSetupAudioInstructions'] = this.state.audioInstructionsOptions.indexOf(e.target.value);
					this.saveRoomInstructions('roomSetupAudioInstructions', window['roomSetupAudioInstructions']);
				}
		}
	else
		{
			value = parseInt(e.target.value);
			if ( isNaN(value) ) { value = ''; }
		}

	this.setState({
		[e.target.id]: value
	}, () => {this.checkForSave(); this.checkCaloriesSave()});	
}

checkForSave=()=>{
	var canSaveRoom = false;

	if ( ( this.state.boxJumpSize !== '' && this.state.hasBoxJump ) || ( !this.state.hasBoxJump ) )
		{
			canSaveRoom = true;
		}
	
	if ( ( this.state.boxingPosition !== '' && this.state.boxingPosition ) || ( !this.state.boxingPosition ) )
		{
			canSaveRoom = true;
		}
	
	if ( ( this.state.boxJumpSize == '' && this.state.hasBoxJump ) || ( this.state.boxingPosition == '' && this.state.boxingPosition ) )
		{
			canSaveRoom = false;
		}
		
	this.setState({canSaveRoomSetup: canSaveRoom});
}

checkCaloriesSave=()=>{
	var canSaveCalories = false;
	
	if ( this.state.caloriesAges !== '' && this.state.caloriesAges !== 0 && this.state.caloriesHeightFeet !== '' && this.state.caloriesHeightInch !== '' && this.state.caloriesGender !== '' && this.state.caloriesWeight !== '' )
		{
			canSaveCalories = true;
		}
		
	if ( this.state.caloriesHeightFeet === 0 && this.state.caloriesHeightInch === 0 )
		{
			canSaveCalories = false;
		}
		
	this.setState({canSaveCalories: canSaveCalories});
}

skipRoomSetup=()=>{
	this.saveBoxJump('boxJumpSize', this.state.boxJumpSize);
	var sendBoxingPosition = '';
	if ( this.state.boxingPosition == 'Left' ) { sendBoxingPosition = 0; }
	else if ( this.state.boxingPosition == 'Right' ) { sendBoxingPosition = 1; }
	this.saveBoxingPosition('boxingPosition', sendBoxingPosition);
	var boxCirclePos = parseInt(this.state.boxingCirclePosition);
	this.saveBoxingPosition('boxingCirclePosition', this.state.boxingCirclePosition);
	window['boxingCirclePosition'] = this.state.boxingCirclePosition;
	var postData = {
						userId: this.state.currentUserData.id, 
						sessionId: this.state.currentUserData.sessionData.id,
						participantHeightFeet: this.state.participantHeightFeet,
						participantHeightInch: this.state.participantHeightInch,
						cameraHeightFeet: this.state.cameraHeightFeet,
						cameraHeightInch: this.state.cameraHeightInch,
						saveHeight: this.state.saveHeight
					};
	
	if ( window['userWhiteboard'][this.state.currentUserData.id] && window['userWhiteboard'][this.state.currentUserData.id].roomSetup.workoutAreaSetupDone )
		{
			var sep = '~@$';
			var message = 'preStreamingRoomSetup'+sep+JSON.stringify(window['userWhiteboard'][this.state.currentUserData.id].roomSetup.workoutConeLocation);
			window['userWhiteboard'][this.state.currentUserData.id].splitRTMSend(this.state.currentUserData.sessionData.hostEmail, message);
		}
	
	window['nextIsSession'] = false;
	var mainthis = this;
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/saveRoomSetup", postData).then(res => {
		$('#local-media').removeClass('roomIsSetup');
		this.setState({canJoinSession: true, showRequiredError: false, showRoomSetup: false}, () => {
			
			var localstoragedata = JSON.parse(localStorage.getItem('userData'));
			mainthis.joinSessionOld(mainthis.state.currentUserData);
			
		});
    }).catch(err => { console.log('saveRoomSetup error - ', err); });
}

saveRoomSetup=()=>{
	if ( this.roomSetupButtonClicked ) { return false; }
	this.roomSetupButtonClicked = true;
	this.saveBoxJump('boxJumpSize', this.state.boxJumpSize);
	var sendBoxingPosition = '';
	if ( this.state.boxingPosition == 'Left' ) { sendBoxingPosition = 0; }
	else if ( this.state.boxingPosition == 'Right' ) { sendBoxingPosition = 1; }
	this.saveBoxingPosition('boxingPosition', sendBoxingPosition);
	var boxCirclePos = parseInt(this.state.boxingCirclePosition);
	this.saveBoxingPosition('boxingCirclePosition', this.state.boxingCirclePosition);
	var postData = {
						userId: this.state.currentUserData.id, 
						sessionId: this.state.currentUserData.sessionData.id,
						participantHeightFeet: this.state.participantHeightFeet,
						participantHeightInch: this.state.participantHeightInch,
						cameraHeightFeet: this.state.cameraHeightFeet,
						cameraHeightInch: this.state.cameraHeightInch,
						saveHeight: this.state.saveHeight
					};
	window['nextIsSession'] = false;
	var mainthis = this;
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/saveRoomSetup", postData).then(res => {
		$('#local-media').removeClass('roomIsSetup');
		this.setState({canJoinSession: true, showRequiredError: false, showRoomSetup: false}, () => {
			mainthis.roomSetupButtonClicked = false;
			window['nextIsSession'] = function () {
				var localstoragedata = JSON.parse(localStorage.getItem('userData'));
				mainthis.joinSessionOld(mainthis.state.currentUserData);
			}
			window.$('.pre-click-zoom').trigger('click');
		});
    }).catch(err => { console.log('saveRoomSetup error - ', err); });
}

saveBoxJump=(statement, value)=>{
	console.log('saveBoxJump', value);
	
	let insertValue = value;
	
	if ( statement == 'boxJumpSize' )
		{
			insertValue = this.state.boxJumpWidth+'x'+this.state.boxJumpHeight;
		}
	
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getBoxingPosition", { 'userId': this.state.currentUserData.id, 'equipmentStatement': statement, 'value': insertValue  }).then(res => {
		  
		var setBagPositions = res.data.responseData;
		var setBagPosition = setBagPositions['boxJumpSize'] ? setBagPositions['boxJumpSize'] : '14x14';
		var boxingPosition = setBagPositions['boxingPosition'] ? setBagPositions['boxingPosition'] : '';
		var boxingCirclePositions = setBagPositions['boxingCirclePosition'] ? parseInt(setBagPositions['boxingCirclePosition']) : 1;
		var boxingPositionState;
		
		if ( boxingPosition != '' )
			{
				boxingPositionState = parseInt(boxingPosition) == 1 ? 'Right' : parseInt(boxingPosition) == 0 ? 'Left' : '';
			}
		else
			{
				boxingPositionState = 'Right';
			}
		
		if ( setBagPosition == '' )
			{
				var dimensionWidth = 14;
				var dimensionHeight = 14;
			}
		else
			{
				var dimensions = setBagPosition.split("x");
				var dimensionWidth = dimensions[0];
				var dimensionHeight = dimensions[1];
			}
		
		if ( isNaN(boxingCirclePositions) )
			{
				boxingCirclePositions = 1;
			}
		
		this.setState({
			boxJumpSize: setBagPosition,
			boxingPosition: boxingPositionState,
			boxJumpWidth: dimensionWidth,
			boxJumpHeight: dimensionHeight,
			boxingCirclePosition: boxingCirclePositions
		});
		
		window['bagPosition'] = boxingPositionState == 'Left' ? 'leftPosition' : 'rightPosition';
		
		window['boxingCirclePosition'] = boxingCirclePositions;
		window['boxJumpSize'] = setBagPosition;
		
		window['boxSelW'] = dimensionWidth;
		window['boxSelH'] = dimensionHeight;
		
		window['boxJumpWidth'] = dimensionWidth*7;
		window['boxJumpHeight'] = dimensionHeight*7;
		
	}).catch(err =>{ console.log('err'); });
}

saveRoomInstructions=(statement, value)=>{
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getBoxingPosition", { 'userId': this.state.currentUserData.id, 'equipmentStatement': statement, 'value': value }).then(res => {
		  
		var roomInstructionsData = res.data.responseData;
		var chosenAudio = roomInstructionsData['roomSetupAudioInstructions'] ? parseInt(roomInstructionsData['roomSetupAudioInstructions']) : 0;
		var chooseAudio = this.state.audioInstructionsOptions[chosenAudio];
		this.setState({
			roomSetupAudioInstructions: chooseAudio
		});
		//window['roomSetupAudioInstructions'] = chosenAudio;
		window['roomSetupAudioInstructions'] = 1;
		console.log(chosenAudio, 'chosenAudio');
		console.log(chooseAudio, 'chooseAudio');
		
	}).catch(err =>{ console.log('err'); });
}

saveBoxingPosition=(statement, value)=>{
	
axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getBoxingPosition", { 'userId': this.state.currentUserData.id, 'equipmentStatement': statement, 'value': value }).then(res => {
	  
}).catch(err =>{ console.log('err'); });
}

saveCalories=()=>{
	var postData = {
						ages: this.state.caloriesAges,
						caloriesHeightFeet: this.state.caloriesHeightFeet,
						caloriesHeightInch: this.state.caloriesHeightInch,
						caloriesGender: this.state.caloriesGender,
						caloriesWeight: this.state.caloriesWeight
					};
					
	let token = JSON.parse(localStorage.getItem('userData')).token;
	axios.defaults.headers.common['Authorization'] = token;
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/saveCaloriesInfo", postData).then(res => {
        window.$('#saved_calories').modal('show'); 
		//this.setState({hasEnteredCalories: true});
		//this.changeMenu('Connect Watch');
    }).catch(err => { console.log('saveCalories error - ', err); });
}

closeRoomPop=()=>{
	 window.$('#saved_calories').modal('hide'); 
}

getRoomSetup=()=>{
	var postData = {
						userId: this.state.currentUserData.id, 
						sessionId: this.state.currentUserData.sessionData.id
					};
					
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/getRoomSetup", postData).then(res => {
		if ( res.data.responseData && res.data.responseData.id )
			{
				this.setState({
					participantHeightFeet: res.data.responseData.participantHeightFeet,
					participantHeightInch: res.data.responseData.participantHeightInch,
					cameraHeightFeet: res.data.responseData.cameraHeightFeet,
					cameraHeightInch: res.data.responseData.cameraHeightInch,
					canJoinSession: true,
					showRequiredError: false
				}, () => {this.checkForSave()});
			}
      
    }).catch(err => { console.log('getRoomSetup error - ', err); });
}

getCaloriesInfo=()=>{
	let token = JSON.parse(localStorage.getItem('userData')).token;
	axios.defaults.headers.common['Authorization'] = token;
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/getCaloriesInfo").then(res => {
		if ( res.data.responseData && res.data.responseData.id )
			{
				this.setState({
					caloriesAges: res.data.responseData.age,
					caloriesHeightFeet: res.data.responseData.heightFeet,
					caloriesHeightInch: res.data.responseData.heightInches,
					caloriesGender: res.data.responseData.gender,
					caloriesWeight: res.data.responseData.weightPounds,
					hasEnteredCalories: true
				}, () => { this.checkCaloriesSave(); });
			}
      
    }).catch(err => { console.log('getCaloriesInfo error - ', err); });
	
}

getCode=()=>{
	if ( this.state.appsMenu === 'connected' ) { return false; }
	
	var postData = {
						userId: this.state.currentUserData.id, 
						sessionId: this.state.currentUserData.sessionData.id
					};
		
	let token = JSON.parse(localStorage.getItem('userData')).token;
	axios.defaults.headers.common['Authorization'] = token;
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/getCodeApps", postData).then(res => {
		if ( res.data.responseData && res.data.responseData.id )
			{
				this.setState({appCode: res.data.responseData.code});
				
				var createdCodeTime = new Date(res.data.responseData.createdAt).getTime();
				var currentTime = new Date().getTime();
				
				var defaultMinutesWatch = 5;
				if ( JSON.parse(localStorage.getItem('userData')).default && JSON.parse(localStorage.getItem('userData')).default.appsCodeExpiredTime )
					{
						defaultMinutesWatch = parseInt(JSON.parse(localStorage.getItem('userData')).default.appsCodeExpiredTime);
					}
		  
				var intervalMilis = defaultMinutesWatch * 60000;
				
				var timeoutTime = (createdCodeTime + intervalMilis) - currentTime + 60000;
				
				var mainthis = this;
				this.codeTimeout = setTimeout(function(){ if ( !window['inStreamingEnter'] ) { mainthis.getCode(); } }, timeoutTime);
			}
		else if ( res.data.responseData && res.data.responseData.alreadyConnected )
			{
				this.changeAppsMenu('connected');
			}
    }).catch(err => { console.log('getCode error - ', err); });
	
	
}

checkAppCode=()=>{
	if ( this.state.appsMenu === 'connected' ) { return false; }
	
	var postData = {code: this.state.appCode};

	axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/checkAppCodeStatus", postData).then(res => {
		if ( res.data.responseData && res.data.responseData.status && res.data.responseData.status === 2 )
			{
				this.changeAppsMenu('connected');
			}
    }).catch(err => { console.log('checkAppCode error - ', err); });
}

getNewCode=()=>{

	var postData = {userId: this.state.currentUserData.id};
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/getNewCode", postData).then(res => {
		this.getCode();
	}).catch(err => { console.log('getNewCode error - ', err); });
}

resetCode=()=>{
	let token = JSON.parse(localStorage.getItem('userData')).token;
	axios.defaults.headers.common['Authorization'] = token;
	axios.get(process.env.REACT_APP_API_URL+"/api/v1/session/resetCode").then(res => {
		this.setState({appsMenu: 'steps'}, () => { this.getCode(); });
	}).catch(err => { console.log('resetCode error - ', err); });
}

validateEmail=(email)=>{
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

sendEmailApps=(resend)=>{
	if ( this.validateEmail(this.state.emailApps) )
		{
			var postData = {email: this.state.emailApps};
			axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/sendInstructionEmail", postData).then(res => {
				this.changeAppsMenu('email_sent');
				if ( resend ) 
					{ 
						window.$('#resended_email').modal('show'); 
						setTimeout(function(){ window.$('#resended_email').modal('hide'); }, 2000);
					}
			}).catch(err => { console.log('sendEmailApps error - ', err); });
		}
	else
		{
			this.setState({errorEmail: true});
		}
}

showErrRequired=()=>{
	this.setState({showRequiredError: true});
}

closeReqError=()=>{
	this.setState({showRequiredError: false});
}

updateVideoResolution=(e, res)=>{
	/* let varId = this.state.currentUserData.id;
	window['viewCaptured'+varId] = false;
	if ( window['resetWhiteDrawSkip'+varId] ) 
		{ 
			
			window['resetWhiteDrawSkip'+varId](varId); 
		} */
		
	let sendVideoInfo;
	if ( e )
		{
			this.setState({[e.target.id]:e.target.value});
			sendVideoInfo = e.target.value;
		}
	else if ( res )
		{
			this.setState({videoResolution:res});
			sendVideoInfo = res;
		}
	
	window['currentResolution'] = sendVideoInfo;
	let sendVideo = sendVideoInfo == 'hd' ? 1 : sendVideoInfo == 'sd' ? 0 : 2; 
	if ( window['electron'] ) { window['changeCameraRes'](sendVideoInfo); }
	//if ( this.state.onDemand ) { window.changeCameraResOnDemand(sendVideoInfo); }
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/changeCustomResolution", { 'resolution': sendVideo, 'userId': this.state.currentUserData.id  }).then(res => {
		 
	}).catch(err =>{ console.log('err'); }); 
}

updateHostVideoResolution=(e)=>{
	let varId = this.state.currentUserData.id;
	
	window['currentResolution'] = e.target.value;
	this.setState({
		hostVideoResolution: e.target.value,
	}, ()=>{
		window.setUserProfilePrestreaming(this.state.hostVideoResolution);
		localStorage.setItem("video-resolution", this.state.hostVideoResolution);
	});
}

hideCurrentModal = (ell) => {
	window.$(ell).modal('hide');
}

changeStepAction = (mod) => {
	console.log('already clicked', this.alreadyClickedButton);
	if ( this.alreadyClickedButton ) { return false; }
	this.alreadyClickedButton = true;
	var setupNameNext;
	console.log(mod);
	var nextStep = mod == 'continue' ? this.state.setupStep + 1 : mod == 'back' ? this.state.setupStep - 1 : this.state.setupStep;
	console.log('nextStep: ', nextStep);
	if ( nextStep < this.state.setupNames.length ) 
		{
			this.setState({
				setupStep: nextStep
			},()=>{
				setupNameNext = this.state.setupNames[this.state.setupStep];
				
				if ( this.state.currentUserData.userType == 2 && localStorage.getItem('turnOfCamera') )
					{
						var disabledCameraOptions = JSON.parse(localStorage.getItem('turnOfCamera'));
				
						if ( disabledCameraOptions )
							{
								disabledCameraOptions.forEach( (item) => { 
									if ( item == "Me (I dont't want to see myself)" )
										{
											this.setState({
												userCameraOff: true
											});
											window['userCameraOff'] = true;
										}
								});
							}
					}
				
				this.setState({
					setupStepName: setupNameNext
				});
				console.log('setupNameNext:', setupNameNext);
				if ( setupNameNext == 'Room Setup' )
					{
						if ( !this.roomAudioPlayed && this.virtualEnabled && !window['userCameraOff'] )
							{
								this.roomAudioPlayed = true;
								window.soundPlay.stopAudio();

								window.soundPlay.playAudio('BeforeRoomSetup'); 
							}
							
						let addObject = {"sessionId": this.state.currentUserData.sessionData.id, "event": "status", "eventType": "waitingLoungeContinue", "userId": this.state.currentUserData.id, "details": JSON.stringify({"msg": "The user pressed the Continue button in the Waiting Lounge"}), "timestamp": Util.getCurrentTimestamp()};
						this.sessionDataStore.addSessionData(addObject);	
						
						if ( this.state.currentUserData.sessionData.ondemandId > 0 ) { this.updateOndemandViwes(); }
						this.joinSession();
							
						console.log('joinSession');
					}
				this.alreadyClickedButton = false;
			});
		}
	else
		{
			let addObject = {"sessionId": this.state.currentUserData.sessionData.id, "event": "status", "eventType": "waitingLoungeContinue", "userId": this.state.currentUserData.id, "details": JSON.stringify({"msg": "The user pressed the Continue button in the Waiting Lounge"}), "timestamp": Util.getCurrentTimestamp()};
			this.sessionDataStore.addSessionData(addObject);
			
			if ( !this.state.onDemand )
				{
					this.joinSession();
					console.log('joinSession3');
				}
			else 
				{
					if ( window['localStreamOnDemandGlobal'] )
						{ 
							window['localStreamOnDemandGlobal'].getVideoTracks().forEach(function(track) { track.stop(); });
							window['localStreamOnDemandGlobal'] = null;
						}
					this.updateOndemandViwes();
					//this.props.history.push("/ondemand");
					this.joinSession();
				}
			console.log('joinSession2');
		}
}

updateOndemandViwes=()=>{
	axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/updateOndemandViews", { 'userId': this.state.currentUserData.id, 'ondemandId' : this.state.currentUserData.sessionData.ondemandId }).then(res => {
		
	}).catch(err =>{ console.log('err--', err); }); 
}


changeRecState=()=>{
	if ( this.state.recfullState )
		{
			this.setState({recfullState: false});
		}
	else
		{
			this.setState({recfullState: true});
		}
}

changenicTrackState=()=>{
	if ( this.state.nicTrack )
		{
			this.setState({nicTrack: false});
		}
	else
		{
			this.setState({nicTrack: true});
		}
}

changenicLocationState=()=>{
	if ( this.state.useLocation )
		{
			this.setState({useLocation: false});
		}
	else
		{
			this.setState({useLocation: true});
		}
}

changeSaveHeight=()=>{
	var saveHeightVar = this.state.saveHeight;
	saveHeightVar = !saveHeightVar;
	this.setState({saveHeight: saveHeightVar});
}
 
showChat = () => {
	window.chatWindow(true);
}
onChatCountUpdated = (count)=>{
	this.setState({chatCount:count});
	localStorage.setItem('unreadMessagesNum', count);
	localStorage.setItem('unreadMessagesClassId', this.state.currentUserData.sessionData.id);
}

applyCameraRestrict = () => {
	  console.log('preconfiguration white cam start');
	  if ( window.whiteCam && window.whiteCam.addOn && window.whiteCam.addOn.CameraChange && window.currentUserData && window.currentUserData.default && parseInt(window.currentUserData.default.useCameraZoomLock) )
		{
			//var currentCamera = $('input[name="video-type"]:checked').val();
			var currentCamera = '';
			if ( window['cameraValue'] )
				{
					currentCamera = window['cameraValue'];
				}
			
			if( currentCamera )
				{
					window.whiteCam.addOn.CameraChange(currentCamera);
					console.log('preconfiguration white cam changed---', currentCamera);
				}
		}
 }

openRoomScreen = () => {
	window.zoomVideo();
}

checkForVirtual = () => {
	var localstoragedata = JSON.parse(localStorage.getItem('userData'));
	var activity = localstoragedata.sessionData.scriptDetail;
	var showVirtualStep = false;
	var disableVirtualScreen = true;
	
	if ( activity && activity.length > 0 ) 	
		{
			for ( var i = 0; i < activity.length; i++ )
					{
						for ( var a = 0; a < activity[i].attribute.length; a++ )
							{
								if ( activity[i].attribute[a].attrLabel === 'Activity Type' )
									{
										if ( activity[i].attribute[a].attrValue === 'Virtual Assistant' || activity[i].attribute[a].attrValue === 'Virtual Equipment' )
											{
												$('#camera_cbx').removeClass('camera_main_holder');
												if ( activity[i].name == 'Box Horizontal' )
													{
														window['hasBoxJump'] = true;
														this.setState({ hasBoxJump: true },()=>{ this.checkForSave(); });
														showVirtualStep = true;
													}
												else if ( activity[i].name == 'Boxing Bag 1' || activity[i].name == 'Boxing Bags 2 - NEW' )
													{
														window['hasBoxing'] = true;
														this.setState({ hasBoxing: true });
														showVirtualStep = true;
													}
													
												if ( !this.state.allCameraPermissionsTurnedOff ) { this.virtualEnabled = true; }
												disableVirtualScreen = false;
											}
									}
							}
					}
		}
	
	if ( !window['electron'] ) { disableVirtualScreen = true; }
	
	if ( !showVirtualStep || !window['electron'] )
		{
			this.disableVirtual(disableVirtualScreen);
		}
	
	if ( !disableVirtualScreen )
		{
			window['hasVirtual'] = true;
		}
}

preStreamingSetup = () => {
	if ( this.clickedOnStartButton ) { return false; }
	let addObject = {"sessionId": this.state.currentUserData.sessionData.id,  "userId": this.state.currentUserData.id, "event": "status", "eventType": "roomSetup", "details": JSON.stringify({"msg": "Start Room Setup button clicked in Waiting Lounge"}), "timestamp": Util.getCurrentTimestamp()};
    this.sessionDataStore.addSessionData(addObject);
	this.clickedOnStartButton = true;
	//$('.start_room_button_holder').addClass('d-none');
	var waitTime = window.currentUserData.whiteboardValues.showRoomSetupCircleAfter ? parseInt(window.currentUserData.whiteboardValues.showRoomSetupCircleAfter) : 3000;
	let mainthis = this;
	this.saveRoomSetup();
	window.stopAudio();
	mainthis.clickedOnStartButton = false;
	/* let addObject2 = {"sessionId": mainthis.state.currentUserData.sessionData.id,  "userId": mainthis.state.currentUserData.id, "event": "status", "eventType": "roomSetup", "details": JSON.stringify({"msg": "Virtual Room Setup Started"}), "timestamp": Util.getCurrentTimestamp()};
	mainthis.sessionDataStore.addSessionData(addObject2); */
	window['preStreamingSetup']();
}

showWaitingLoungePopup = (popup) => {
	$('.main_container_configuration').addClass('blur_background');
	$('#'+popup).removeClass('d-none');
}

hideWaitingLoungePopup = (popup) => {
	$('.main_container_configuration').removeClass('blur_background');
	$('#'+popup).addClass('d-none');
}

checkRoomSetup = () => {
	var roomSetDone = true;
			
	if ( !window['userWhiteboard'][this.state.currentUserData.id] || (window['userWhiteboard'][this.state.currentUserData.id] && !window['userWhiteboard'][this.state.currentUserData.id].roomSetup.workoutAreaSetupDone) )
		{
			roomSetDone = false;
		}
		
	this.setState({roomSetupDone: roomSetDone});
		
	return roomSetDone;
}

setDefResolutionInstructor=(mod)=>{
	
	if ( this.state.currentUserData.userType === 1 )
		{
			this.setState({
				hostVideoResolution: mod,
			},()=>{
				localStorage.setItem("video-resolution", this.state.hostVideoResolution);
			});
		}
}

showWatchAppPopup=()=>{
	this.setState({
		watchAppPopupShown: true
	},()=>{ this.showWaitingLoungePopup('watchAppPopup')});
}

switchToNextStep=(mod)=>{
	var showStep = mod == 'continue' ? 2 : mod == 'back' ? 1 : 3;
	if ( mod == 'finish' )
		{
			this.hideWaitingLoungePopup('watchAppPopup');
			this.saveCalories();
			this.setState({
				shownWatchAppScreen: 1
			});
		}
	else
		{
			this.setState({
				shownWatchAppScreen: showStep
			});
		}
}

roomSetupNextStep=()=>{
	if ( window['streamingPage'] ){ /*window['roomSetupNextStepInSession']();*/ }
	else {
		console.log('roomSetupNextStep');
		let currentRoomSetupStep = this.state.roomSetupStep;
		let nextRoomSetupStep = this.state.roomSetupStep;
		let nextRoomSetupTitle = this.state.roomSetupTitle;
		let nextRoomSetupText = this.state.roomSetupText;
		let nextRoomSetupButtonText = this.state.roomSetupButtonText;
		let nextRoomSetupImage = this.state.roomSetupImage;
		let innerHoldVar = this.state.innerHold;
		console.log('roomSetupNextStep', nextRoomSetupTitle);
		if ( currentRoomSetupStep == 1 )
			{	
				let addObject = {"sessionId": this.state.currentUserData.sessionData.id, "event": "status", "eventType": "passReadRequirements", "userId": this.state.currentUserData.id, "details": JSON.stringify({"msg": "User passed Read Requirements"}), "timestamp": Util.getCurrentTimestamp()};
				this.sessionDataStore.addSessionData(addObject);
		
				window.soundPlay.stopAudio();
				window.soundPlay.playAudio('ContinuePlayRoomSetup');
				var mainthis = this;
				var roomSetupTimer = 10;
				
				var roomSetupInterval = setInterval(function(){
					if ( mainthis.clickedOnFirstSkip ) { $('#partBigCounter').addClass('d-none'); roomSetupTimer = 1; }
					roomSetupTimer--;
					
					if ( roomSetupTimer <= 5 && !mainthis.clickedOnFirstSkip )
						{
							$('#partCounterNum').text(roomSetupTimer);
							$('#partBigCounter').removeClass('d-none');
						}
						
					if ( roomSetupTimer == 0 )
						{
							mainthis.preStreamingSetup();
							clearInterval(roomSetupInterval);
							$('#partBigCounter').addClass('d-none');
							if ( mainthis.clickedOnFirstSkip && window.skipMediaPipeCount ) { window.skipMediaPipeCount(); }
						}
				}, 1000);
			}
		
		if ( this.state.roomSetupButtonText == 'Skip' && this.state.roomSetupSecondButton == 'Retry' )
			{
				window['userWhiteboard'][this.state.currentUserData.id].trackerActions.disableMediaPipe();
				this.showHideRoomSetup(true);
			}
		if ( !this.clickedOnFirstSkip && this.state.roomSetupTitle == 'Stand in the marked area' )
			{
				this.clickedOnFirstSkip = true;
				window['alreadyClickedOnSkip'] = true;
			}
			
		if ( !this.clickedOnSkip && ( this.state.roomSetupTitle == 'Tilt your camera up' || this.state.roomSetupTitle == 'Tilt your camera down') )
			{
				this.clickedOnSkip = true;
				console.log(this.state.roomSetupTitle, 'roomSetupTitle');
				window.finishMediaPipeCalculationInnit();
				window['alreadyClickedOnSkip'] = false;
				this.clickedOnFirstSkip = false;
				this.clearTryAgain();
				
				setTimeout(function(){
					window['usingPose'] = true;
				}, 3000);
			}
			
		if ( currentRoomSetupStep < this.state.roomSetupTitleNames.length )
			{	
				nextRoomSetupStep = currentRoomSetupStep+1;
				nextRoomSetupTitle = this.state.roomSetupTitleNames[currentRoomSetupStep];
				nextRoomSetupText = this.state.roomSetupTextNames[currentRoomSetupStep];
				nextRoomSetupButtonText = this.state.roomSetupButtonTextNames[currentRoomSetupStep];
				nextRoomSetupImage = this.state.roomSetupImageNames[currentRoomSetupStep];
				innerHoldVar = this.state.innerHoldSteps[currentRoomSetupStep];
			}
			
		if ( nextRoomSetupStep == this.state.roomSetupTitleNames.length )
			{
				this.showHideRoomSetup(false);
			}
		
		console.log('roomSetupNextStep22', nextRoomSetupTitle);
		this.setState({
			roomSetupStep: nextRoomSetupStep,
			roomSetupTitle: nextRoomSetupTitle,
			roomSetupText: nextRoomSetupText,
			roomSetupButtonText: nextRoomSetupButtonText,
			roomSetupImage: nextRoomSetupImage,
			innerHold: innerHoldVar
		});
	}
}

callTiltMessage=(innerText)=>{
	if ( window['streamingPage'] ){ window['callTiltMessageInSession'](); }
	else 
		{
			this.setState({
				roomSetupTitle: innerText,
				roomSetupText: '',
				roomSetupButtonText: 'Skip',
				roomSetupImage: '',
				innerHold: ''
			});
		}
}

showSkipAndRetry=()=>{
	this.setState({
		roomSetupButtonText: 'Skip',
		roomSetupSecondButton: 'Retry'
	});
}

callMediaTilt=()=>{
	window['usingPose'] = true;
}

showSkipAndTryAgain=()=>{
	window['usingPose'] = false;
	this.setState({
		roomSetupButtonText: 'Skip',
		roomSetupSecondButton: 'Try Again'
	});
}

tryAgainTilt=()=>{
	window['startTiltTimeout']();
	this.setState({
		roomSetupSecondButton: ''
	});
}

retryRoomSetup=()=>{
	window.retryRoomSetup(parseInt(this.state.currentUserData.id));
	
	this.setState({
		roomSetupSecondButton: ''
	});
}

showHideRoomSetup=(hideMessage)=>{
	this.setState({
		hideRoomSetupMessage: hideMessage,
		roomSetupSecondButton: ''
	});
}

clearTryAgain=()=>{
	window['usingPose'] = true;
	this.setState({
		roomSetupSecondButton: ''
	});
}

dontHaveAnyCam = (mod) =>{
	this.setState({dontHaveAnyCam: mod});
	
	if ( mod == true )
		{
			this.disableVirtual(true);
		}
	else
		{
			if ( window['electorn'] && ( window['hasBoxing'] || window['hasBoxJump'] ) && !this.state.allCameraPermissionsTurnedOff )
				{
					this.setState({
						setupNames: ['Device Settings', 'Equipment Setup', 'Room Setup', ''],
						numberOfSetupSteps: 2,
					});
					this.virtualEnabled = true;
				}
		}
}

dontHaveAnyMic = (mod) =>{
	this.setState({hideTestMic: mod});
}

disableVirtual = (mod) => {
	console.log('disableVirtual', mod);
	var setupNameArray = this.state.setupNames;
	var numberOfSetupStepsNum = this.state.numberOfSetupSteps;
	var setupNameIndex = setupNameArray.indexOf('Equipment Setup');
	if (setupNameIndex !== -1) {
		numberOfSetupStepsNum = numberOfSetupStepsNum -1;
		setupNameArray.splice(setupNameIndex, 1);
		if ( mod == true ) 
			{
				this.virtualEnabled = false;
				this.setState({
					setupNames: ['Device Settings'],
					numberOfSetupSteps: 1
				});
			}
		else
			{
				console.log('numberOfSetupSteps');
				this.setState({
					setupNames: ['Device Settings', 'Room Setup'],
					numberOfSetupSteps: 1
				});
			}
	}
}

optionDisableVirtual = (mod) => {
	
	this.setState({disableVirtualOption: !this.state.disableVirtualOption});
	
	this.disableVirtual(mod);
	window['userCameraOff'] = mod;
	this.virtualEnabled = !mod;
	
	if ( mod == false && window['hasVirtual'] )
		{
			if ( window['hasVirtualEquipment'] || window['hasBoxJump'] || window['hasBoxing'] )
				{
					this.setState({setupNames: ['Device Settings', 'Equipment Setup', 'Room Setup', ''],
								numberOfSetupSteps: 2,
							});
				}
			else
				{
					this.setState({setupNames: ['Device Settings', 'Room Setup'],
								numberOfSetupSteps: 1,
							});
				}
		}
}

changeCamera=(e)=>{
	this.setState({[e.target.id]:e.target.value});
	
	if ( window['changeCameraSelect'] )
		{
			window['changeCameraSelect'](e.target.value);	
		}
}

loadPreVideoElement=()=>{
	var videoSrc = this.state.currentUserData.sessionData.replayVideo ? this.state.currentUserData.sessionData.replayVideo : this.state.currentUserData.sessionData.videoPath;
	var preVideoElement = document.createElement('video');
	preVideoElement.src = encodeURI(videoSrc);
	preVideoElement.id = 'replayClassVideo'; 
	preVideoElement.classList.add("replay_video", "video_hidden");
	preVideoElement.preload = 'auto';
	preVideoElement.controls = false;
	preVideoElement.muted = true;
	preVideoElement.height = 240;
	preVideoElement.width = 340;
	preVideoElement.muted = false;
	console.log(preVideoElement, 'preVideoElement');
	var mainAppHolder = document.getElementById('root');
	
	mainAppHolder.appendChild(preVideoElement);
}

cameraSelectValue=(mod)=>{
		this.setState({
			cameraSelect: mod
		});
	}
	
getVideoResolution = () =>{
	  var videoInfo;
	  var putVideoInfo;
	  axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getCustomResolution", { 'userId': this.state.currentUserData.id  }).then(res => {
			videoInfo = res.data.responseData.videoResolutionParticipant;
			console.log(videoInfo, 'videoInfo');
			putVideoInfo = videoInfo == 1 ? 'hd' : videoInfo == 0 ? 'sd' : 'hdp';
			window.getDevicesOnDemand();
			this.updateVideoResolution(false, putVideoInfo);
		}).catch(err =>{ console.log('err--', err); }); 
  }

render() {
	
  let sessionData = this.state.currentUserData.sessionData;
  let logo = sessionData.channelImage != null ? sessionData.channelImage : 'images/v-logo.png';
  return (
       <div>
        <div id="fullbodymsg-one" className="screen_popup p-4 bg-grayy rounded white_hdng d-none">
          <p>Walk away from the camera until your head and feet are inside this frame...</p>
        </div>
        <div id="fullbodymsg-two" className="screen_popup p-4 bg-grayy rounded white_hdng d-none">
          <p>Once all of you is in this box, mark the spot!</p>
        </div>

        <div id="hostStuckMsg" className="screen_popup p-4 bg-grayy rounded white_hdng d-none">
          &#123;<span id="hostfname">{this.state.currentUserData.sessionData.hostFirstName}</span>&#125; } has a poor internet connection and cannot start the Class. We have sent them tips on how to improve their connection and start the Class. Please wait for a few minutes for the Class to start.
        </div>
		
		<div className={classnames("main_container_configuration", { 'overflow-hidden': this.state.setupStepName == 'Room Setup'})} id="media-config">
			<div className={classnames("start_room_button_holder", { 'd-none': this.state.setupStepName != 'Room Setup'})}>
				<div className={classnames("room_setup_message_hold inside_session_button", {'d-none': this.state.hideRoomSetupMessage, 'room_setup_message_small': this.state.roomSetupStep != 1, "room_setup_inner_holder": this.state.innerHold})}>
					<div className={classnames("", {'d-none': this.state.roomSetupImage == ''})}>
						<div className={classnames("room_setup_loader", {'d-none': this.state.roomSetupImage != 'room_setup_loader'})}>
						  <div className="room_setup_loader_inner"></div>
						</div>
						<div className={classnames("done_check", {'d-none': this.state.roomSetupImage != 'done_check'})}>
							<svg className="checkmark room_setup_checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg> 
						</div>
					</div>
					<div className={classnames("room_setup_message_title", {'d-none': this.state.roomSetupTitle == '', 'room_setup_smaller_title': this.state.roomSetupStep == 1})}>{this.state.roomSetupTitle}</div>
					<div className={classnames("room_setup_message", {'d-none': this.state.roomSetupText == '', 'room_setup_smaller_text': this.state.roomSetupStep == 1})} dangerouslySetInnerHTML={{__html: this.state.roomSetupText}}></div>
					<div className={classnames("room_setup_message_button_hold", {'d-none': this.state.roomSetupButtonText == '' && this.state.roomSetupSecondButton == ''})}>
						{this.state.roomSetupSecondButton == 'Try Again' &&
							<div className={classnames("room_setup_message_button", {'d-none': this.state.roomSetupSecondButton == '', 'room_setup_button_small': this.state.roomSetupButtonText !== ''})} onClick={this.tryAgainTilt}>
								{this.state.roomSetupSecondButton}
							</div>
						}
						<div className={classnames("room_setup_message_button", {'d-none': this.state.roomSetupButtonText == '', 'room_setup_button_small': this.state.roomSetupSecondButton !== ''})} onClick={this.roomSetupNextStep}>
							{this.state.roomSetupButtonText}
						</div>
						{this.state.roomSetupSecondButton == 'Retry' &&
							<div className={classnames("room_setup_message_button", {'d-none': this.state.roomSetupSecondButton == '', 'room_setup_button_small': this.state.roomSetupButtonText !== ''})} onClick={this.retryRoomSetup}>
								{this.state.roomSetupSecondButton}
							</div>
						}
					</div>
				</div>
				<div className="top_room_setup_bar d-none"></div>
				<div className="bottom_room_setup_bar d-none"></div>
			</div>
			<div className="top_channel_info">
				<div className="channel_info_content">
					<div className="ps_info_content">
						<div className="leave_class_hold">
							<div className="leave_class_image" onClick={ () => this.showWaitingLoungePopup('leaveClassPopup')}></div>
							<div className="leave_class_text" onClick={ () => this.showWaitingLoungePopup('leaveClassPopup')}>Leave</div>
						</div>
						<div className="class_setup_text">Class Setup</div>
					</div>
					<div className="class_info_hold">
						<div className="class_name_text">{sessionData.name}</div>
							{this.state.showContinueButton &&
								<div>
									<>
									{ this.state.currentUserData.userType == 1 ?
										<div className="session_info_content">Class can Start</div>
									:
										<div className="session_info_content">Class has Started</div>
									}
									</>
								</div>
							}
					</div>
				</div>
				{/*  this.state.rtmConnected &&
						<>
						<div className="chat-text" onClick={() => this.showChat()}>
						<div className={'badge-wrapper'}>
            				<span className={classnames({ 'badge':true, 'badge-pill':true, 'badge-success':true, 'd-none': this.state.chatCount > 0 ? false : true})}>{this.state.chatCount > 0 ? (this.state.chatCount <= 9 ? this.state.chatCount : 9) : ''}<span className={classnames({ 'd-none': this.state.chatCount > 9 ? false : true})}>+</span></span>
          				</div>

						<img src="./images/chat.svg" className="chat_ps"></img>
						</div>
						<Chat className="chat-lounge" onChatCountUpdated={this.onChatCountUpdated}/>
						</> */
				}
			</div>
			{/* <div className="session_streaming_container">
				<div className="session_name_ps">{sessionData.name}</div>
				{ !this.state.canStartSession &&
					<div className="relative">
						<div className="waiting_host_container 1">
							<div className="inline_session_starting">
								<div className="session_clock"></div>
								<div className="session_info_content"></div>
							</div>
							<div className="online_container">
								<div className="online_users_drop" onClick={this.openUsers}>Online
									<span id="totalonline">{this.state.usersOnline}</span>
									<div className="drop_arrow"></div>
									{ this.state.isOpenUsersDrop && this.state.usersOnline > 0 &&
										<div className="online_drop_users">
											{ this.state.sessionUsers.length > 0 &&
												<div>
													{ this.state.sessionUsers && this.state.sessionUsers.sort((a,b) => a.dataPosition - b.dataPosition).map((item, key) => 
														<>
															{ (item.id != this.state.currentUserData.sessionData.hostId && item.isOnline ) && 
																	<div className={classnames("one_drop_user", { 'even_user': key % 2 == 0 })} key={key}>
																		<div className="user_online_img" style={{backgroundImage: "url('" + item.image + "')"}}>
																			{ item.isOnline && <div className="online_user_drop"></div> }
																			{ !item.isOnline && <div className="online_user_drop offline_user_drop"></div> }
																		</div>
																		{item.firstName} {item.lastName}
																	</div>
															}
														</>
													)}
												</div>
											}
											{ this.state.sessionUsers.length == 0 &&
												<div className="empty_users">No available users.</div>
											}
										</div>
									}
								</div>
							</div>
						</div>
					</div>
				}
				{ this.state.canStartSession &&
					<div className="relative">
						<div className="waiting_host_container 2">
							{ this.state.currentUserData.userType === 1 &&
								<div className="inline_session_starting">
									<div className="session_clock"></div>
									<div className="session_info_content">Class can Start</div>
								</div>
							}
							{ this.state.currentUserData.userType !== 1 &&
								<div className="inline_session_starting">
									<div className="session_clock"></div>
									<div className="session_info_content">Class has Started</div>
								</div>
							}
							{ this.state.canJoinSession && <div className="join_streaming" data-attr={this.state.currentUserData.userType} onClick={this.joinSession.bind(this, this.state.currentUserData)}>JOIN CLASS</div> }
							{ !this.state.canJoinSession && <div className="join_streaming opacity_room" onClick={this.showErrRequired}>JOIN CLASS</div> }
							<div className="online_container">
								<div className="online_users_drop" onClick={this.openUsers}>Online
									<span id="totalonline">{this.state.usersOnline}</span>
									<div className="drop_arrow"></div>
									{ this.state.isOpenUsersDrop && this.state.usersOnline > 0 &&
										<div className="online_drop_users">
											{ this.state.sessionUsers.length > 0 &&
												<div>
													{ 
														this.state.sessionUsers && this.state.sessionUsers.sort((a,b) => a.dataPosition - b.dataPosition).map((item, key) => 
														<>
																{ (item.id != this.state.currentUserData.sessionData.hostId && item.isOnline) && 
			  														<div className={classnames("one_drop_user", { 'even_user': key % 2 == 0 })} key={key}>
			  															<div className="user_online_img" style={{backgroundImage: "url('" + item.image + "')"}}>
			  																{ item.isOnline && <div className="online_user_drop"></div> }
			  																{ !item.isOnline && <div className="online_user_drop offline_user_drop"></div> }
			  															</div>
			  															{item.firstName} {item.lastName}
			  														</div>
	  														}
  														</>
													)}
												</div>
											}
											{ this.state.sessionUsers.length == 0 &&
												<div className="empty_users">No available users.</div>
											}
										</div>
									}
								</div>
							</div>
							{ this.state.showRequiredError && 
								<div className="required_room_info">Please enter the Requirement information in the My Room Setup Menu Option.
									<div className="danger_icon"></div>
									<div className="cancel_error" onClick={this.closeReqError}></div>
								</div> 
							}
						</div>
					</div>
				}
			</div> */}
			<div className="session_options_container">
					<div className="step_buttons_hold">
							<div className="step_buttons_inner_hold">
								{ this.state.showContinueButton ?
									<div>
									{ this.state.setupStepName != 'Device Settings' && <div className="join_streaming ml0 step_button_continue wl_back_button" onClick={ () => this.changeStepAction('back')}>Back</div> }
									<div className={classnames("join_streaming ml0 step_button_continue", { 'wl_continue_button': this.state.setupStepName != 'Device Settings' }, { 'd-none': !window['devicesLoaded']})} onClick={ () => this.changeStepAction('continue')}>Continue</div>
									</div>
									:
									<div className="session_info_content before_start_timer"></div>
								}
							</div>
					</div>
				<div className="class_inner_container">
					<div className="step_top_container">
						<div className="step_count">{this.state.setupStep+1}/{this.state.numberOfSetupSteps}</div>
						<div className="streaming_option_title">{this.state.setupStepName}</div>
						{ this.state.setupStepName == 'Device Settings' && <div className="join_streaming ml0 step_button_continue setup_watch_app_button" onClick={ () => this.showWatchAppPopup()}>Setup Watch App</div> }
					</div>
					{/* <div className="streaming_options_menu">
						<div className="padding_menu">
							<div className={classnames("streaming_option", { 'active_streaming_option': this.state.activeMenu === 'Camera Settings' })} onClick={() => this.changeMenu('Camera Settings')}>Camera Settings</div>
							<div className={classnames("streaming_option", { 'active_streaming_option': this.state.activeMenu === 'Mic & Speaker Settings' })} onClick={() => this.changeMenu('Mic & Speaker Settings')}>Mic & Speaker Settings</div>
							
				{ this.state.currentUserData.userType !== 1 &&
							<div className={classnames("streaming_option relative_opt_menu ", { 'active_streaming_option': this.state.activeMenu === 'Connect Watch' })} onClick={() => this.changeMenu('Connect Watch')}>Get Remote & Watch App
								<div className="info_circle" onClick={this.openInfoApps}></div>
								{ this.state.openedInfo &&
									<div className="info_watch_container">
										<div className="arrow_info"></div>
										<div className="info_close" onClick={this.openInfoApps}></div>
										<div className="info_watch_title">Use the Virdio Remote and Smartwatch App!</div>
										<div className="info_watch_text">Get the most out of your workout! Install the Smartwatch App to track Heart Rate, Calories, and VO2Max.</div>
										<div className="info_watch_text">Download the Remote App to make your life easier!</div>
									</div>
								}
							</div>
				}
				
							{ this.state.currentUserData.userType !== 1 &&
								<div className={classnames("streaming_option relative_opt_menu ", { 'active_streaming_option': this.state.activeMenu === 'Track calories burned' })} onClick={() => this.changeMenu('Track calories burned')}>Track calories burned</div>
							}
						</div>
					</div> */}
					
					<div className="opened_menu_streaming">
						<div className={classnames("step_screen", { 'd-none': this.state.setupStepName != 'Device Settings' && this.state.setupStepName != 'Room Setup'})}>
							<div className="cameras_container setup_top_container" id="media-content">
								<div id="video-media-content" className={classnames({'for_cameras_main': this.state.activeMenu === 'My Room Setup', 'd-none': (this.state.currentUserData.isMarketplaceChannel == 1 && JSON.parse(localStorage.getItem('userData')).userType === 2 && (this.state.allCameraPermissionsTurnedOff || this.state.dontHaveAnyCam))})}></div>
								<select className={classnames('main_select cameraSelect', {'d-none': !window['devicesLoaded'] || (this.state.currentUserData.isMarketplaceChannel == 1 && JSON.parse(localStorage.getItem('userData')).userType === 2 && (this.state.allCameraPermissionsTurnedOff || this.state.dontHaveAnyCam))})} 
								id="cameraSelect" value={this.state.cameraSelect}
								onChange = {(e)=>{this.changeCamera(e)}} >
								</select>
								
								{ (JSON.parse(localStorage.getItem('userData')).userType === 2 || (this.state.onDemand)) &&
										<div className="turning_video_container camera_info_left">
											{ (this.state.currentUserData.isMarketplaceChannel == 1 && (this.state.allCameraPermissionsTurnedOff || this.state.dontHaveAnyCam)) &&
												<div>
													<div class="turning_video_title">Camera</div>
													<div className="cameraTurnedOff">
														<div className="cameraIcon">
															<div className="videoOff"></div>
														</div>
													</div>
												</div>
											}
											<div className={classnames("camera_info_hold", { 'd-none': (this.state.currentUserData.isMarketplaceChannel == 1 && this.state.dontHaveAnyCam )})}>
												<div className="turning_video_title">Turn off my video for</div>
												<div className="turning_options_container">
													{ this.state.turnVideoOptions.map((item, key) => 
														<div className="one_off_option">
															<input type="checkbox" class="form-radio" id={"camopt-"+key} onClick={() => this.changeTurningOff(item)} checked={this.state.turnVideoArray.indexOf(item) > -1 ? 'checked' : ''}></input>
															<label for={"camopt-"+key}>{item}</label>
														</div>
													)}
												</div>
											</div>
											<div className={classnames("camera_info_hold", { 'd-none': (this.state.currentUserData.isMarketplaceChannel == 1 && (this.state.allCameraPermissionsTurnedOff || this.state.dontHaveAnyCam))})}>
												<div className="col-md-11 px-4 definition_hold">
													<div className="turning_video_title">Choose video resolution</div>
													<div className="overflow-hidden mr-3 w-100 form-group1">
														<select className="main_select"
															id="videoResolution" value = {this.state.videoResolution}
															onChange = {(e)=>{this.updateVideoResolution(e)}}>
															<option value="sd" id="0">SD</option>
															<option value="hd" id="1">HD</option>
															<option value="hdp" id="2">HD+</option>
														</select>                          
													</div>
												</div>
											</div>
										</div>
								}
								
								{ this.state.activeMenu === 'Camera Settings' && window['devicesLoaded'] && JSON.parse(localStorage.getItem('userData')).userType === 1 && this.state.currentUserData.isMarketplaceChannel == 1 && !this.state.onDemand &&
									<div className="col-md-11 px-4 definition_hold">
										<div className="turning_video_title">Choose video resolution</div>
										<div className="overflow-hidden mr-3 w-100 form-group1">
											<select className="main_select"
												id="hostVideoResolution" value={this.state.hostVideoResolution}
												onChange = {(e)=>{this.updateHostVideoResolution(e)}}>
												<option value="1080p" id="2">High Definition 1080p</option>
												<option value="720p" id="3">High Definition</option>
												<option value="360p" id="4">Standard Definition</option>
												<option value="180p" id="5">Low Definition</option>
											</select>
										</div>
									</div>
								}
							</div>
							<div className="cameras_container">
								<div className="all_width_mic width_speaker d-none" id="speaker-media-content"></div>
								<div className={"all_width_mic " + ((JSON.parse(localStorage.getItem('userData')).userType === 2 && this.state.currentUserData.isMarketplaceChannel == 1 && ( this.state.hideTestMic || this.state.onDemand ) ) ? 'd-none' : '')} id="audio-media-content"></div>
								{ window['hasVirtual'] && this.state.disableVirtualPermitted &&
									<div className="turning_video_container for_all_test_sp" style={{paddingTop: 0+'px'}}>
										<div className="turning_video_title">Augmented Reality Options</div>
										<div className="turning_options_container">
											<div className="one_off_option">
												<input type="checkbox" className="form-radio" id="disable-virtual" onClick={() => this.optionDisableVirtual(!this.state.disableVirtualOption)} checked={this.state.disableVirtualOption ? 'checked' : ''}></input>
												<label for="disable-virtual">Disable Virtual</label>
											</div>
										</div>
									</div>
								}
							</div>
							<div className={classnames("apps_container", { 'd-none': this.state.activeMenu !== 'Connect Watch' })}>
								{ this.state.appsMenu === 'instruction' &&
									<div className="email_container">
										<div className="instruction_text">Instruction will be sent to the email address below.</div>
										<div className="centered_full">
											<div className="inline_input">
												<input type="email" className={classnames("main_input", { 'error_input': this.state.errorEmail })} id="emailApps" value={this.state.emailApps} onChange={(e)=>this.setState({[e.target.id]: e.target.value, errorEmail: false})} />
											</div>
											<div className="join_streaming" onClick={() => this.sendEmailApps(false)}>SEND</div>
										</div>
										<div className="centered_full mt30">
											<div className="join_streaming ml0" onClick={() => this.changeAppsMenu('steps')}>CONNECT NOW</div>
										</div>
									</div>
								}
								{ this.state.appsMenu === 'email_sent' &&
									<div className="email_container">
										<div className="instruction_text succes_instructor">
											<span className="relative">An email with installation instructions has been sent to
												<div className="success_mark"></div>
											</span> 
											<span className="sucess_span"> {this.state.emailApps}</span>
										</div>
										<div className="centered_full">
											<div className="join_streaming none_margin" onClick={() => this.sendEmailApps(true)}>RESEND EMAIL</div>
										</div>
										<div className="centered_full mt30">
											<div className="join_streaming ml0" onClick={() => this.changeAppsMenu('steps')}>CONNECT NOW</div>
										</div>
									</div>
								}
								{ this.state.appsMenu === 'steps' &&
									<div className="steps_container">
										<div className="padding_steps relative">
											<div className="back_instruction" onClick={() => this.changeAppsMenu('instruction')}></div>
											<div className="step_title">STEP 1:</div>
											<div className="step_info">Launch <span>Watch App</span></div>
											<div className="step_title">STEP 2:</div>
											<div className="step_info">Enter 4 digit code in <span>Watch App</span></div>
											<div className="digits_container">{this.state.appCode}</div>
										</div>
										<div className="centered_full pt20">
											<div className="join_streaming ml0" onClick={() => this.getNewCode()}>GET NEW CODE</div>
										</div>
									
									</div>
								}
								{ this.state.appsMenu === 'connected' &&
									<div className="connected_container">
										<div className="instruction_text succes_instructor">
											<span className="relative">Your watch is now connected.
												<div className="success_mark"></div>
											</span> 
										</div>
										<div className="centered_full pt20">
											<div className="join_streaming ml0" onClick={this.resetCode}>RESET</div>
										</div>
									</div>
								}
							</div>
							<div className={classnames("calories_container", { 'd-none': this.state.activeMenu !== 'Track calories burned' })}>
								<div className="calories_title">We need your age, weight, height and gender to calculate calories burned.</div>
								<div className="calories_input_container">
									<div className="calories_one_container">
										<div className="setup_title">Age</div>
										<div className="for_select_setups">
											<div className="one_select_option select_full">
												<select className="main_select" id="caloriesAges" value={this.state.caloriesAges} onChange={this.handleFilterChange}>
													{ this.state.agesArray.map((item, key) => 
														<option value={item} key={key}>{item}</option>
													)}
												</select>
											</div>
										</div>
									</div>
									<div className="calories_one_container widder_calories">
										<div className="setup_title">Height</div>
										<div className="for_select_setups">
											<div className="one_select_option">
												<select className="main_select select_room height_margin" id="caloriesHeightFeet" value={this.state.caloriesHeightFeet} onChange={this.handleFilterChange}>
													{ this.state.feetOptions.map((item, key) => 
														<option value={item} key={key}>{item}</option>
													)}
												</select>
												<div className="select_title_room">feet</div>
											</div>
											<div className="one_select_option calories_margin">
												<select className="main_select select_room" id="caloriesHeightInch" value={this.state.caloriesHeightInch} onChange={this.handleFilterChange}>
													{ this.state.inchOptions.map((item, key) => 
														<option value={item} key={key}>{item}</option>
													)}
												</select>
												<div className="select_title_room">inch</div>
											</div>
										</div>
									</div>
									<div className="calories_one_container">
										<div className="setup_title">Gender</div>
										<div className="for_select_setups">
											<div className="one_select_option select_full">
												<select className="main_select" id="caloriesGender" value={this.state.caloriesGender} onChange={this.handleFilterChange}>
													{ this.state.gendersArray.map((item, key) => 
														<option value={item} key={key}>{item}</option>
													)}
												</select>
											</div>
										</div>
									</div>
									<div className="calories_one_container widder_calories">
										<div className="setup_title">Weight</div>
										<div className="for_select_setups">
											<div className="one_select_option weight_select_container">
												<select className="main_select select_room weight_select_inner" id="caloriesWeight" value={this.state.caloriesWeight} onChange={this.handleFilterChange}>
													{ this.state.poundsArray.map((item, key) => 
														<option value={item} key={key}>{item}</option>
													)}
												</select>
												<div className="select_title_room">lbs</div>
											</div>
											
										</div>
									</div>
									<div className="centered_full txt_left">
										{ this.state.canSaveCalories && <div className="join_streaming ml0" onClick={this.saveCalories}>SAVE</div> }
										{ !this.state.canSaveCalories && <div className="join_streaming ml0 opacity_room">SAVE</div> }
									</div>
								</div>
							</div>
						</div>
						<div className={classnames("step_screen", { 'd-none': this.state.setupStepName != 'Equipment Setup'})}>
							<div className="cameras_container">
								<div className="top_step_text">This class uses Virtual Equipment<br></br>Set your equipment preferences for this class</div>
								<div className="equipment_chosing_container">
									{ this.state.hasBoxJump &&
										<div className="mb35">
											<div className="equipment_step_title">Box Horizontal Size</div>
											<div className="for_select_setups">
												<div className="one_select_option select_option_pop">
													<select className="main_select select_room_pop" id="boxJumpWidth" value={this.state.boxJumpWidth} onChange={this.handleFilterChange}>
														{ this.state.boxJumpOptions.map((item, key) => 
															<option value={item} key={key}>{item}</option>
														)}
													</select>
													<div className="select_title_room">in W</div>
												</div>
												<div className="one_select_option select_option_pop">
													<select className="main_select select_room_pop" id="boxJumpHeight" value={this.state.boxJumpHeight} onChange={this.handleFilterChange}>
														{ this.state.boxJumpOptions.map((item, key) => 
															<option value={item} key={key}>{item}</option>
														)}
													</select>
													<div className="select_title_room">in H</div>
												</div>
											</div>
										</div>
									}
									{ this.state.hasBoxing &&
										<div className="mb35">
											<div className="equipment_step_title">Preferred Hand and Circle for boxing</div>
											<div className="for_select_setups">
												<div className="one_select_option select_option_pop">
													<div className="one_off_option">
														<input type="checkbox" className="form-radio wl_step_checkbox" onClick={() => this.changeBoxingPosition('Left')} checked={this.state.boxingPosition == 'Left' ? 'checked' : ''}></input>
														<label className="boxing_position_label">Left</label>
														<input type="checkbox" className="form-radio wl_step_checkbox" onClick={() => this.changeBoxingPosition('Right')} checked={this.state.boxingPosition == 'Right' ? 'checked' : ''}></input>
														<label className="boxing_position_label">Right</label>
														<input type="checkbox" className="form-radio wl_step_checkbox" onClick={() => this.changeBoxingCirclePosition(1)} checked={this.state.boxingCirclePosition == 1 ? 'checked' : ''}></input>
														<label className="boxing_position_label">90 Degrees</label>
														<input type="checkbox" className="form-radio wl_step_checkbox" onClick={() => this.changeBoxingCirclePosition(0)} checked={this.state.boxingCirclePosition == 0 ? 'checked' : ''}></input>
														<label>45 Degrees</label>
													</div>
												</div>
											</div>
										</div>
									}
								</div>
							</div>
						</div>
					</div>
					{/* <div className="footer_ps">
						<div className="powered_streaming"></div>
						<div className="footer_logo"></div>
					</div> */}
				</div>

				<SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
			</div>
		</div>
		
      <div className="prescreen-popup" id="media-config">

      <div className="mw-100" role="document">

        <div className="modal-content">

    <div className="modal pr-0 fade show onboarding-modal" id="electron_permission" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog small_width modal-dialog-centered ">
              <div className="modal-content bg-transparent">
                  <div className="modal-body px-4 py-5 bg-grayy radius-10">
                  {window['electron'] && osname==="Windows" ? this.WindowElectronMsg() : this.MacosElectronMsg()}
                  </div>
                  <div className="text-center mt-4">
                  <button type="button" className="join_streaming ml0 mt-0 mx-2 try-again-access" data-dismiss="modal">Try Again</button>
              </div>
          </div>
        </div>
    </div>
		
		 <div className="modal pr-0 fade show onboarding-modal" id="microphone_electron_error" data-backdrop="static" data-keyboard="false">
            <div className="modal-dialog small_width modal-dialog-centered ">
                <div className="modal-content bg-transparent">
                    <div className="modal-body px-4 py-5 bg-grayy radius-10"> 
                        <div><p className="text-white text-center font-22 px-3">Virdio Media Access Error</p>
                            <p className="text-white font-18 px-3">Virdio could not get access to microphone</p>
                        </div>
                    </div>
                    <div className="text-center mt-4">
                        <button type="button" className="join_streaming ml0 mt-0 mx-2 try-again-access" data-dismiss="modal">Try Again</button>
                    </div>
                </div>
            </div>
        </div>

         {/* -------------show permission step guideline POPUP-------------- */}

         <div className="modal pr-0 fade show onboarding-modal" id="permission_mac_chrome" data-backdrop="static" data-keyboard="false">
              <div className="modal-dialog small_width modal-dialog-centered ">
                    <div className="modal-content bg-transparent">
                        <div className="modal-body px-4 py-5 bg-grayy radius-10"> 
                        {/*<button type="button" className="close white close-btn1" data-dismiss="modal">×</button>*/}

                        { this.state.showMicMsg &&
                          <span>
                            {osname==="Linux"   && browserName === 'Chrome'  ? this.linuxosChromeMsgMic() :'' }
                            {osname==="Linux"   && browserName === 'Firefox' ? this.linuxosFirefoxMsgMic() :'' }
                            {osname==="Ubuntu"  && browserName === 'Chrome'  ? this.linuxosChromeMsgMic() :''  }
                            {osname==="Ubuntu"  && browserName === 'Firefox' ? this.linuxosFirefoxMsgMic() :'' }
                            {osname==="Windows" && browserName === 'Chrome'  ? this.WindowsChromeMsgMic() :'' }
                            {osname==="Windows" && browserName === 'Firefox' ? this.WindowsFirefoxMsgMic() :'' }
                            {osname==="Windows" && browserName === 'Edge'    ? this.WindowsEdgeMsgMic() :'' }
                            {osname==="Mac OS"  && browserName === 'Chrome'  ? this.MacosChromeMsgMic() :'' }
                            {osname==="Mac OS"  && browserName === 'Firefox' ? this.MacosFirefoxMsgMic() :'' }
                            {osname==="Mac OS"  && browserName === 'Safari'  ? this.MacosSafariMsgMic() :'' }
                          </span>
                        }
                        { this.state.showCameraMsg &&
                          <span>
                            {osname==="Linux"   && browserName === 'Chrome'  ? this.linuxosChromeMsg() :'' }
                            {osname==="Linux"   && browserName === 'Firefox' ? this.linuxosFirefoxMsg() :'' }
                            {osname==="Ubuntu"  && browserName === 'Chrome'  ? this.linuxosChromeMsg() :''  }
                            {osname==="Ubuntu"  && browserName === 'Firefox' ? this.linuxosFirefoxMsg() :'' }
                            {osname==="Windows" && browserName === 'Chrome'  ? this.WindowsChromeMsg() :'' }
                            {osname==="Windows" && browserName === 'Firefox' ? this.WindowsFirefoxMsg() :'' }
                            {osname==="Windows" && browserName === 'Edge'    ? this.WindowsEdgeMsg() :'' }
                            {osname==="Mac OS"  && browserName === 'Chrome'  ? this.MacosChromeMsg() :'' }
                            {osname==="Mac OS"  && browserName === 'Firefox' ? this.MacosFirefoxMsg() :'' }
                            {osname==="Mac OS"  && browserName === 'Safari'  ? this.MacosSafariMsg() :'' }
                          </span>
                        }
                        </div>
                        <div className="text-center mt-4">
                        <button type="button" className="join_streaming ml0 mt-0 mx-2 try-again-access" data-dismiss="modal">Try Again</button>
                    </div>
                </div>
            </div>
        </div>

        {/* -------------DEVICE NOT FOUND guideline POPUP-------------- */}        
        <div className="modal pr-0 fade show onboarding-modal" id="device_not_found" data-backdrop="static" data-keyboard="false">
            <div className="modal-dialog small_width modal-dialog-centered ">
                <div className="modal-content bg-transparent">
                    <div className="modal-body px-4 py-5 bg-grayy radius-10">
                        <button type="button" className="close white close-btn1" data-dismiss="modal">×</button> 
                        <p className="text-white text-center font-22 px-3 py-1 mb-0">Virdio could not find a camera on this device. If there is a camera on this device, enable it or switch to another device</p>
                    </div>
                    <div className="text-center mt-4">
                        <button type="button" className="join_streaming ml0 mt-0 mx-2 try-again-access" data-dismiss="modal">Try Again</button>
                    </div>
                </div>
            </div>
        </div>

        </div>
      </div>
      </div>

      <div id="media-access-alert" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
          <div className={"modal-dialog modal-confirm modal-dialog-centered " + ((JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel && JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel == 1 && this.state.currentUserData.userType == 2) ? 'moreW' : '')}>
            <div className="modal-content bg-grayy px-4 position-relative radius-10">
              <div className="modal-header justify-content-center px-0 border-bottm">
                <h5 className="modal-title white_hdng" id="media-access-alert-heading">Media Access Error</h5>
              </div>
              <div className="modal-body">
                <div>
                  <p className="text-white text-center font-20 mb-5" id="media-access-alert-text">We could not get access to your camera/microphone, please let us know how you would like to proceed</p>
                </div>
              </div>
              <div className="ok_btn_cont w-100 text-center">
                <button className="ok-btn-access mx-2 try-again"><a href="javascript:void(0)" className="text-white">Enable Access</a></button>

                { ( this.state.currentUserData.userType == 2 && (sessionData.isCameraRequired == 0 || (JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel && JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel == 1))) && 
                    <button id="joinWithoutCamera" className="ok-btn-access mx-2" onClick={this.joinWithoutCamera.bind(this)}><a href="javascript:void(0)" className="text-white">Join Without Camera</a></button>
                }

                <button className="ok-btn-access mx-2 bg-green" onClick={this.callfunction.bind(this)}><a href="javascript:void(0)" className="text-white">Switch Device</a></button>
                <button className="ok-btn-access mx-2 bg-trans-red"><a href="mailto:support@virdio.com?subject=Media%20Access%20Denied" className="text-white">Contact Virdio</a></button>
              </div>
            </div>
          </div>
      </div>
		
		<div className="stream_pop_holder d-none" id="ejectedPop">
			<div className="stream_inner_pop">
				<div className="modal-header justify-content-center px-0 border-bottm">
				  <h5 className="modal-title white_hdng">Ejected from class</h5>
				</div>
				<div className="modal-body">
					  <div>
							<p className="text-white text-center font-20 mb-5">Instructor ejected you from class. Message your instructor for more informations.</p>
					  </div>
				</div>
			</div>					
		</div>
		
      <div id="multi-media-access-alert" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-confirm modal-dialog-centered">
          <div className="modal-content bg-grayy px-4 position-relative radius-10">
            <div className="modal-header justify-content-center px-0 border-bottm">
              <h5 className="modal-title white_hdng">Joining Class</h5>
            </div>
            <div className="modal-body">
              <div>
                <p className="text-white text-center font-20 mb-5">You will be redirected in <strong><span id="stream-joining-timer">{this.state.currentUserData.default.streamRedirectDuration}</span></strong> seconds</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="mic-camera-select-alert" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-confirm modal-dialog-centered">
          <div className="modal-content bg-grayy px-4 position-relative radius-10">
            <div className="modal-header justify-content-center px-0 border-bottm">
              <h5 className="modal-title white_hdng">Camera & Microphone</h5>
            </div>
            <div className="modal-body">
              <div>
                <p className="text-white text-center font-20 mb-5">Hi {this.state.currentUserData.firstName}, your class has already started. Would you like to Join the Class or Select your Camera/Mic/Speaker?</p>
              </div>
            </div>
            <div className="ok_btn_cont w-100 text-center ch_button_pad">
              <button className="new_des_confirm" id="proceed">JOIN</button>
              <button className="new_des_confirm ml-2 bg-trans-red" id="change-setting">Camera/Mic/Speaker</button>
            </div>
          </div>
        </div>
      </div>

      <div id="multi-device-login-alert" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-confirm modal-dialog-centered">
          <div className="modal-content bg-grayy px-4 position-relative radius-10">
            <div className="modal-header justify-content-center px-0 border-bottm">
              <h5 className="modal-title white_hdng">Multiple Device Login</h5>
            </div>
            <div className="modal-body">
              <div>
                <p className="text-white font-17 mb-5">Another device has logged in using the same email address. You are being logged out from this class.  If you did not authorize the other login, please change your password.</p>
              </div>
            </div>
            <div className="ok_btn_cont w-100 text-center">
              <button className="new_des_confirm" onClick={this.callfunction.bind(this)}>Ok</button>
            </div>
          </div>
        </div>
      </div>
	  
	  <div id="saved_calories" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-confirm modal-dialog-centered">
          <div className="modal-content bg-grayy px-4 position-relative radius-10">
            <div className="modal-header justify-content-center px-0 border-bottm">
              <h5 className="modal-title white_hdng">Calories</h5>
            </div>
            <div className="modal-body">
              <div>
                <p className="succes_text">You successfully saved your Calories Information.</p>
              </div>
            </div>
            <div className="ok_btn_cont w-100 text-center">
              <button className="new_des_confirm" onClick={this.closeRoomPop}>OK</button>
            </div>
          </div>
        </div>
      </div>
	  
	  <div id="resended_email" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-confirm modal-dialog-centered">
          <div className="modal-content bg-grayy px-4 position-relative radius-10">
            <div className="modal-header justify-content-center px-0 border-bottm">
              <h5 className="modal-title white_hdng">Resend Email</h5>
            </div>
            <div className="modal-body">
              <div>
                <p className="succes_text">You successfully resended Email.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
	  
	  <div id="calories_watch_error" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-confirm modal-dialog-centered">
          <div className="modal-content bg-grayy px-4 position-relative radius-10">
            <div className="modal-header justify-content-center px-0 border-bottm">
              <h5 className="modal-title white_hdng">Calories</h5>
            </div>
            <div className="modal-body">
              <div>
                <p className="succes_text">Before you connect your Watch please enter your calories information.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="camera-access-alert" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog modal-confirm modal-dialog-centered">
            <div className="modal-content bg-grayy px-4 position-relative radius-10">
              <div className="modal-header justify-content-center px-0 border-bottm">
                <h5 className="modal-title white_hdng">Media Access Error</h5>
              </div>
              <div className="modal-body">
                <div>
                  <p className="text-white text-center font-20 mb-5">Virdio is unable to access your camera or microphone even though access was granted. Please check if it’s being used by another app or restart your device.</p>
                </div>
              </div>
              <div className="ok_btn_cont w-100 text-center">
                <button className="new_des_confirm" data-dismiss="modal">OK</button>
              </div>
            </div>
          </div>
      </div>

      <div id="camera-detection-alert" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog modal-confirm modal-dialog-centered">
            <div className="modal-content bg-grayy px-4 position-relative radius-10">
              <div className="modal-header justify-content-center px-0 border-bottm">
                <h5 className="modal-title white_hdng">Media Access Error</h5>
              </div>
              <div className="modal-body">
                <div>
                  <p className="text-white text-center font-20 mb-5">Virdio could not detect camera on this device.</p>
                </div>
              </div>
              <div className="ok_btn_cont w-100 text-center">

                { ( this.state.currentUserData.userType == 2 && (sessionData.isCameraRequired == 0 || (JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel && JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel == 1))) && 
                    <button className="ok-btn-access mx-2" onClick={this.joinWithoutCamera.bind(this)}><a href="javascript:void(0)" className="text-white">Join Without Camera</a></button>
                }

				<button className="done mt-0 mx-2 try-again-access fn-normal">Try Again</button>
                <button className="ok-btn-access mx-2 bg-green" onClick={this.callfunction.bind(this)}><a href="javascript:void(0)" className="text-white">Switch Device</a></button>
                <button className="ok-btn-access mx-2 bg-trans-red"><a href="mailto:support@virdio.com?subject=Media%20Access%20Denied" className="text-white">Contact Virdio</a></button>
              </div>
            </div>
          </div>
      </div>

      <div id="mic-detection-alert" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog modal-confirm modal-dialog-centered">
            <div className="modal-content bg-grayy px-4 position-relative radius-10">
              <div className="modal-header justify-content-center px-0 border-bottm">
                <h5 className="modal-title white_hdng">Media Access Error</h5>
              </div>
              <div className="modal-body">
                <div>
                  <p className="text-white text-center font-20 mb-5">Virdio could not detect microphone on this device.</p>
                </div>
              </div>
              <div className="ok_btn_cont w-100 text-center">
				{ this.state.currentUserData.userType == 2 && JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel && JSON.parse(localStorage.getItem("userData")).isMarketplaceChannel == 1 ?
                    <button className="ok-btn-access mx-2" onClick={this.joinWithoutMicrophone.bind(this)}><a href="javascript:void(0)" className="text-white">Join Without Microphone</a></button>
					:
					<></>
                }
                <button className="ok-btn-access mx-2 bg-green" onClick={this.callfunction.bind(this)}><a href="javascript:void(0)" className="text-white">Switch Device</a></button>
                <button className="ok-btn-access mx-2 bg-trans-red"><a href="mailto:support@virdio.com?subject=Media%20Access%20Denied" className="text-white">Contact Virdio</a></button>
              </div>
            </div>
          </div>
      </div>

      <div id="device-access-msg" className="modal fade" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-confirm modal-dialog-centered">
          <div className="modal-content bg-grayy px-4 position-relative radius-10">
            <div className="modal-body">
              <div>
                {this.state.currentUserData.userType == 1
                  ? 
					<span>
						{ window['electron'] && osname == "Windows" && <p className="text-white text-left font-20 mb-2">1. Select Camera & Microphone you want to use for the Class.</p> }
						{ ( !window['electron'] || osname !== "Windows" ) && <p className="text-white text-left font-20 mb-2">1. Press "Allow" when requested for Camera & Microphone access.</p> }
						<p className="text-white text-left font-20 mb-2">2. After selecting Camera & Microphone you want to use for the Class, press JOIN.</p>
					</span>
                  : <span>
						{ window['electron'] && osname == "Windows" && <p className="text-white text-left font-20 mb-2">1. Select Camera & Microphone you want to use for the Class.</p> }
						{ window['electron'] && osname == "Windows" && <p className="text-white text-left font-20 mb-2">2. Once your Instructor is ready to Start the Class, you will be asked to JOIN</p> }
						{ ( !window['electron'] || osname !== "Windows" ) && <p className="text-white text-left font-20 mb-2">1. Press "Allow" when requested for Camera & Microphone access.</p> }
						{ ( !window['electron'] || osname !== "Windows" ) && <p className="text-white text-left font-20 mb-2">2. Select Camera & Microphone you want to use for the Class</p> }
						{ ( !window['electron'] || osname !== "Windows" ) && <p className="text-white text-left font-20 mb-2">3. Once your Instructor is ready to Start the Class, you will be asked to JOIN</p> }
					</span>
                }
              </div>
            </div>
            <div className="ok_btn_cont w-100 text-center">
              <button className="new_des_confirm" onClick={this.grantAccess.bind(this)}>OK</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="participent_host_alert">
        <div className="modal-dialog">
          <div className="modal-content equipmodalbg">

            <div className="modal-header headerborder">
              <h4 className="modal-title white">Class Alert</h4>
              <button type="button" className="close white closepopup" onClick={this.partmodalClose.bind(this)} data-dismiss="modal">&times;</button>
            </div>

            <div className="modal-body">
              <p>
                Your Instructor Is Not Yet Login Kindly Wait For Instructor Login!!!!!
              </p>
            </div>
          </div>
        </div>
      </div>
	  
	  {/* NO HEAR MIC */}
      <div id="notgoodmic" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-confirm modal-dialog-centered">
          <div className="modal-content bg-grayy px-4 position-relative radius-10">
            <div className="modal-header justify-content-center px-0 border-bottm">
              <h5 className="modal-title white_hdng">Microphone/Speaker not working</h5>
            </div>
            <div className="modal-body">
              <div>
                <p className="text-white font-20 mb-4">Switch Microphone/Speaker and try again.</p>
              </div>
            </div>
            <div className="ok_btn_cont">
              <button className="new_des_confirm" data-dismiss="modal">OK</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal pr-0 fade show onboarding-modal" id="participant_stuck_msg" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog small_width modal-dialog-centered ">
              <div className="modal-content bg-transparent">
                  <div className="modal-body px-4 py-5 bg-grayy radius-10"> 
                    <button type="button" className="close white close-btn1 d-none" data-dismiss="modal">×</button>
                    <div>
                        <p className="text-white font-22 px-3">&#123;{this.state.currentUserData.sessionData.hostFirstName}&#125; has started &#123;{this.state.currentUserData.sessionData.name}&#125; and your network is too poor to join. Here are some steps you can try to improve your network and join the Class.</p>
                        <p className="text-white font-22 px-4 pt-3">
                            <ul>
                              <li>Restart your device</li>
                              <li>Switch to a different Wi-Fi network if available</li>
                              <li>Switch to a different device</li>
                              <li>Restart your router</li>
                              <li>Switch to your Cellular network</li>
                              <li>Contact network administrator to add following destination domains and the corresponding ports to the firewall whitelist:<br />agora.io<br />TCP - 8443; 9130; 9131; 9136; 9137; 9140, 9141<br />UDP - 1080; 8000; 8130; 8443; 9120; 9121; 9700; 25000</li>
                            </ul>
                        </p>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                      <button type="button" className="done mt-0 mx-2" data-dismiss="modal">OK</button>
                  </div>
              </div>
          </div>
      </div>

      <div className="modal pr-0 fade show onboarding-modal" id="host_stuck_msg" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog small_width modal-dialog-centered ">
              <div className="modal-content bg-transparent">
                  <div className="modal-body px-4 py-5 bg-grayy radius-10"> 
                    <button type="button" className="close white close-btn1 d-none" data-dismiss="modal">×</button>
                    <div>
                        <p className="text-white font-22 px-3">&#123;{this.state.currentUserData.firstName}&#125; you have a poor network and cannot join your Class. Here are some steps you can try to improve your connection and join the Class.</p>
                        <p className="text-white font-22 px-4 pt-3">
                            <ul>
                              <li>Restart your device</li>
                              <li>Switch to a different Wi-Fi network if available</li>
                              <li>Switch to a different device</li>
                              <li>Restart your router</li>
                              <li>Switch to your Cellular network</li>
                              <li>Contact network administrator to add following destination domains and the corresponding ports to the firewall whitelist:<br />agora.io<br />TCP - 8443; 9130; 9131; 9136; 9137; 9140, 9141<br />UDP - 1080; 8000; 8130; 8443; 9120; 9121; 9700; 25000</li>
                            </ul>
                        </p>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                      <button type="button" className="done mt-0 mx-2" data-dismiss="modal">OK</button>
                  </div>
              </div>
          </div>
      </div>
	  
	  <div id="no-playlist-found" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-confirm modal-dialog-centered">
          <div className="modal-content bg-grayy px-4 position-relative radius-10">
            <div className="modal-header justify-content-center px-0 border-bottm">
              <h5 className="modal-title white_hdng">No Playlist Songs Found</h5>
            </div>
            <div className="modal-body">
              <div>
                <p className="text-white font-20 mb-4">The songs in the playlist selected with this Class are no longer on your device. To play music during this Class, please use the Screen Share Option under the Music icon.</p>
              </div>
            </div>
            <div className="ok_btn_cont">
              <button className="new_des_confirm" onClick={ () => window.hideNoPlaylist() }>OK</button>
            </div>
          </div>
        </div>
      </div>
	  
      <div className="modal pr-0 fade show onboarding-modal" id="tracker-error" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog small_width modal-dialog-centered ">
              <div className="modal-content bg-transparent">
                  <div className="modal-body px-4 py-5 bg-grayy radius-10"> 
					<div className="modal-header justify-content-center px-0 border-bottm">
						<h5 className="modal-title white_hdng">Virtual Equipment Error</h5>
					</div>
                    <div>
                        <p className="text-white font-20 mb-4">Oops, there was an error with Virtual Equipment. If you would like to use Virtual Equipment in this Class, please logout and quit the Virdio app then log back in. If you would like to continue without Virtual Equipment, press OK.</p>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                      <button type="button" className="done mt-0 mx-2" onClick={ () => this.hideCurrentModal('#tracker-error')}>OK</button>
                  </div>
              </div>
          </div>
      </div>
	  
	<div className="modal pr-0 fade show onboarding-modal" id="retry_permission_devices" data-backdrop="static" data-keyboard="false">
		  <div className="modal-dialog modal-dialog-centered ">
				<div className="modal-content bg-transparent">
					<div className="modal-body text-center px-4 py-5 bg-grayy radius-10"> 
						<span>
							<div>
							  <span className="text-white font-22 px-3">Press "Allow" when requested for Camera & Microphone access.</span>
							</div>
						</span>
					</div>
					<div className="text-center mt-4">
					<button type="button" className="join_streaming ml0 mt-0 mx-2" data-dismiss="modal">Try Again</button>
				</div>
			</div>
		</div>
	</div>
	
	<div className="waiting_lounge_popup d-none" id="leaveClassPopup">
		<div className="wl_popup_inner txt_center">
			<div className="wl_popup_text">Leave Class?</div>
			<div className="join_streaming ml0 wl_popup_left_button" onClick={ () => this.hideWaitingLoungePopup('leaveClassPopup')}>No</div>
			<div className="join_streaming ml0 wl_popup_right_button" onClick={this.callfunction.bind(this)}>Yes</div>
		</div>
	</div>
	
	<div className="waiting_lounge_popup d-none" id="watchAppPopup">
		<div className="wl_popup_container">
			<div className="watch_info_container">
				<div className="wl_popup_inner watch_app_popup_hold">
					{ this.state.shownWatchAppScreen == 1 &&
						<>
						<div className="setup_watch_part">
							<div className="wl_popup_text txt_left fn-normal">Setup Watch App</div>
							<div className="watch_track_text">Track your calories with the Virdio watch app</div>
							<div className="watch_steps_container">
								<div className="watch_steps_text step_text_inline"><b>Step 1</b><br></br>Launch <span className="watch_app_open">watch app</span></div>
								<div className="watch_google_play"></div>
								<div className="watch_google_play watch_apple_image"></div>
							</div>
							<div className="watch_steps_container">
								<div className="watch_steps_text"><b>Step 2</b><br></br>Enter this 4 digit code</div>
								<div className="digits_container">{this.state.appCode}</div>
							</div>
						</div>
						</>
					}
					{ this.state.shownWatchAppScreen == 2 &&
						<>
						<div className="setup_watch_part">
							<div className="wl_popup_text txt_left fn-normal">Setup Watch App</div>
							<div className="watch_track_text">We need your age, weight, height and gender to calculate the calories burned.</div>
							<div className="watch_steps_container">
								<div className="calories_input_container">
									<div className="calories_one_container">
										<div className="setup_title">Age</div>
										<div className="for_select_setups">
											<div className="one_select_option select_full">
												<select className="main_select" id="caloriesAges" value={this.state.caloriesAges} onChange={this.handleFilterChange}>
													{ this.state.agesArray.map((item, key) => 
														<option value={item} key={key}>{item}</option>
													)}
												</select>
											</div>
										</div>
									</div>
									<div className="calories_one_container">
										<div className="setup_title">Gender</div>
										<div className="for_select_setups">
											<div className="one_select_option select_full">
												<select className="main_select" id="caloriesGender" value={this.state.caloriesGender} onChange={this.handleFilterChange}>
													{ this.state.gendersArray.map((item, key) => 
														<option value={item} key={key}>{item}</option>
													)}
												</select>
											</div>
										</div>
									</div>
									<div className="calories_one_container">
										<div className="setup_title">Height</div>
										<div className="for_select_setups">
											<div className="one_select_option height_margin">
												<select className="main_select select_room" id="caloriesHeightFeet" value={this.state.caloriesHeightFeet} onChange={this.handleFilterChange}>
													{ this.state.feetOptions.map((item, key) => 
														<option value={item} key={key}>{item}</option>
													)}
												</select>
												<div className="select_title_room">feet</div>
											</div>
											<div className="one_select_option calories_margin">
												<select className="main_select select_room" id="caloriesHeightInch" value={this.state.caloriesHeightInch} onChange={this.handleFilterChange}>
													{ this.state.inchOptions.map((item, key) => 
														<option value={item} key={key}>{item}</option>
													)}
												</select>
												<div className="select_title_room">inch</div>
											</div>
										</div>
									</div>
									<div className="calories_one_container">
										<div className="setup_title">Weight</div>
										<div className="for_select_setups">
											<div className="one_select_option weight_select_container">
												<select className="main_select select_room weight_select_inner" id="caloriesWeight" value={this.state.caloriesWeight} onChange={this.handleFilterChange}>
													{ this.state.poundsArray.map((item, key) => 
														<option value={item} key={key}>{item}</option>
													)}
												</select>
												<div className="select_title_room">lbs</div>
											</div>
											
										</div>
									</div>
									{/* <div className="centered_full txt_left">
										{ this.state.canSaveCalories && <div className="join_streaming ml0" onClick={this.saveCalories}>SAVE</div> }
										{ !this.state.canSaveCalories && <div className="join_streaming ml0 opacity_room">SAVE</div> }
									</div> */}
								</div>
							</div>
						</div>
						</>
					}
					<div className="setup_watch_part right_side_cont">
						<div className="watch_cover"></div>
						<div className="watch_separater"></div>
						<div className="watch_buttons_hold">
							{ this.state.shownWatchAppScreen == 1 &&
								<>
								<div className="join_streaming ml0 step_button_continue wl_back_button" onClick={ () => this.hideWaitingLoungePopup('watchAppPopup')}>Cancel</div>
								<div className="join_streaming ml0 step_button_continue wl_continue_button" onClick={ () => this.switchToNextStep('continue')}>Continue</div>
								</>
							}
							{ this.state.shownWatchAppScreen == 2 &&
								<>
								<div className="join_streaming ml0 step_button_continue wl_back_button" onClick={ () => this.switchToNextStep('back')}>Back</div>
								{this.state.canSaveCalories ? <div className="join_streaming ml0 step_button_continue wl_continue_button" onClick={ () => this.switchToNextStep('finish')}>Finish</div> :
								<div className="join_streaming ml0 step_button_continue wl_continue_button continue_disabled">Finish</div>
								}
								</>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
	<div className="pre-streaming-counter">
		<div className="bigCountShow d-none" id="partBigCounter">
			<div className="countNumD2C" id="partCounterNum">0</div>
		</div>
	</div>
	
    <ToastContainer newestOnTop={false} transition={Flip} />
	
	{ this.state.showRoomSetup &&
		<div className="setup_room_holder d-none">
			<div className="room_container_pop">
				<div className="welcome_room">Welcome to your class</div>
				<div className="welcome_room_subtext">Placing virtual objects in your class requires camera to be 90&deg; from floor.</div>
				<div className="pop_room_container">
					<div className="selects_container">
					{/* <div className="mb35">
							<div className="setup_title">Camera height from floor</div>
							<div className="for_select_setups">
								<div className="one_select_option select_option_pop">
									<select className="main_select select_room_pop" id="cameraHeightFeet" value={this.state.cameraHeightFeet} onChange={this.handleFilterChange}>
										{ this.state.feetOptions.map((item, key) => 
											<option value={item} key={key}>{item}</option>
										)}
									</select>
									<div className="select_title_room">feet</div>
								</div>
								<div className="one_select_option select_option_pop">
									<select className="main_select select_room_pop" id="cameraHeightInch" value={this.state.cameraHeightInch} onChange={this.handleFilterChange}>
										{ this.state.inchOptions.map((item, key) => 
											<option value={item} key={key}>{item}</option>
										)}
									</select>
									<div className="select_title_room">inch</div>
								</div>
							</div>
						</div>
						<div className="mb35">
							<div className="setup_title">Select your height</div>
							<div className="for_select_setups">
								<div className="one_select_option select_option_pop">
									<select className="main_select select_room_pop" id="participantHeightFeet" value={this.state.participantHeightFeet} onChange={this.handleFilterChange}>
										{ this.state.feetOptions.map((item, key) => 
											<option value={item} key={key}>{item}</option>
										)}
									</select>
									<div className="select_title_room">feet</div>
								</div>
								<div className="one_select_option select_option_pop">
									<select className="main_select select_room_pop" id="participantHeightInch" value={this.state.participantHeightInch} onChange={this.handleFilterChange}>
										{ this.state.inchOptions.map((item, key) => 
											<option value={item} key={key}>{item}</option>
										)}
									</select>
									<div className="select_title_room">inch</div>
								</div>
							</div>
						</div> */ }
						{this.state.hasBoxJump &&
							<div className="mb35">
								<div className="setup_title">Box Horizontal Size</div>
								<div className="for_select_setups">
									<div className="one_select_option select_option_pop">
										<select className="main_select select_room_pop" id="boxJumpSize" value={this.state.boxJumpSize} onChange={this.handleFilterChange}>
											{ this.state.boxJumpOptions.map((item, key) => 
												<option value={item} key={key}>{item}</option>
											)}
										</select>
										<div className="select_title_room">inches</div>
									</div>
								</div>
							</div>
						}
						{this.state.hasBoxing &&
							<div className="mb35">
								<div className="setup_title">Boxing Bag Position</div>
								<div className="for_select_setups">
									<div className="one_select_option select_option_pop">
										<select className="main_select select_room_pop" id="boxingPosition" value={this.state.boxingPosition} onChange={this.handleFilterChange}>
											{ this.state.boxingOptions.map((item, key) => 
												<option value={item} key={key}>{item}</option>
											)}
										</select>
									</div>
								</div>
							</div>
						}
						{ /*
						<div className="mb35">
							<div className="for_select_setups">
								<div className="save_height_cbx" onClick={() => this.changeSaveHeight()}>Save Height Information
									<input type="checkbox" className="form-radio height_cbx" checked={this.state.saveHeight} />
								</div>
							</div>
						</div>*/ }
						{ /* <div className="one_off_option">
							<input type="checkbox" class="form-radio" id={"saveHeight"} onClick={() => this.changeSaveHeight()} checked={this.state.saveHeight ? 'checked' : ''}></input>
							<label for={"saveHeight"}>Save Height Information</label>
						</div> */ }
						{ /* <div className="one_off_option">
							<input type="checkbox" class="form-radio" id={"recfull"} onClick={() => this.changeRecState()} checked={this.state.recfullState ? 'checked' : ''}></input>
							<label for={"recfull"}>Record Full Class</label>
						</div>
						<input type="text" className="main_input" id="recLink" value={this.state.recLink} onChange={(e)=>this.setState({'recLink': e.target.value})} />
						*/ }
						{ /* <div className="one_off_option">
							<input type="checkbox" class="form-radio" id={"nicTrack"} onClick={() => this.changenicTrackState()} checked={this.state.nicTrack ? 'checked' : ''}></input>
							<label for={"nicTrack"}>Use Tracker Feet</label>
						</div> */ }

						<div className="mb35">
							<div className="setup_title">Room Setup Audio Instructions</div>
							<div className="for_select_setups">
								<div className="one_select_option select_option_pop">
									<select className="main_select select_room_pop room_setup_select" id="roomSetupAudioInstructions" value={this.state.roomSetupAudioInstructions} onChange={this.handleFilterChange}>
										{ this.state.audioInstructionsOptions.map((item, key) => 
											<option value={item} key={key}>{item}</option>
										)}
									</select>
								</div>
							</div>
						</div>
						
						{/* <div className="one_off_option">
							<input type="checkbox" class="form-radio" id={"useLocation"} onClick={() => this.changenicLocationState()} checked={this.state.useLocation ? 'checked' : ''}></input>
							<label for={"useLocation"}>Use Previous Setup Location</label>
						</div> */}
					</div>
					<div className="room_img_container"></div>
				</div>
				<div className="room_continue_container">
					{ this.state.canSaveRoomSetup && ( ( !this.state.hasEquipment && this.state.currentUserData.sessionData.usingMarkup == 0 ) || this.state.noRoomSetup ) && <div className="join_streaming ml0" onClick={this.skipRoomSetup}>CONTINUE</div> }
					{ !this.state.canSaveRoomSetup && ( ( !this.state.hasEquipment && this.state.currentUserData.sessionData.usingMarkup == 0 ) || this.state.noRoomSetup ) && <div className="continue_disabled">CONTINUE</div> }
					{ ( this.state.hasEquipment || this.state.currentUserData.sessionData.usingMarkup == 1 ) && !this.state.noRoomSetup && !window['viewCaptured'+this.state.currentUserData.id] && 
						<div>
							{ this.state.roomSetupDone || this.state.userCameraOff ?
								<div className="join_streaming ml0" onClick={this.skipRoomSetup}>CONTINUE</div>
								:
								<>
									<div className="join_streaming ml0 start_room_setup" onClick={this.saveRoomSetup}>ROOM SETUP</div>
									{ this.state.WASRequiredInWaitingLounge == 0 && this.state.isMarketplaceChannel == 1 &&
										<div className="join_streaming ml0" onClick={this.skipRoomSetup}>SKIP ROOM SETUP</div>
									}
								</>
							}
							
						</div>
					}
					{ ( this.state.hasEquipment || this.state.currentUserData.sessionData.usingMarkup == 1 ) && !this.state.noRoomSetup && window['viewCaptured'+this.state.currentUserData.id] && 
						<div>
							<div className="join_streaming ml0" onClick={this.skipRoomSetup}>CONTINUE</div>
						</div>
					}
				</div>
			</div>
		</div>
	}

      </div>
    );
  }
}
PreConfiguration.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth
});
export default connect(
  mapStateToProps,
  { logoutUser }
)(PreConfiguration);